import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty, map, size } from "lodash";
import { withTranslation } from "react-i18next"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Calender from "../Activities/calander"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios"
import DeleteModal from "../../components/Common/DeleteModal";
import { getClientDetail, getListingType, getClientDeals, deleteClientDeal, getUserDetail } from "../../store/actions"
import Moment from 'react-moment';
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import classnames from "classnames"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { BlobServiceClient } from '@azure/storage-blob';
import Swal from 'sweetalert2'
import { MultiSelect } from "primereact/multiselect";
import { FilterMatchMode } from "primereact/api";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,

  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Collapse,
  Alert
} from "reactstrap"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import ClientDealBreadcrumbs from "components/Common/ClientDealBreadcrumb";
import RsAdNew from "components/buttons/Adnew";
import SaveButton from "components/buttons/save";
import { API_URL } from "helpers/app_url";
import ActionDelete from "components/buttons/actionDelete";
import CurrencyFormat from "react-currency-format";
import { azureConfig } from "helpers/azureConfig";
import moment from "moment";
import RsLink from "components/buttons/rsLink";
import { Dropdown } from "primereact/dropdown";
import { UPLOADTEXT } from "constants/layout";
import SafeField from "helpers/SafeField";


class ClientDeals extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deals: props.deals || [],
      appTypes: [],
      appPriories: [],
      appLocTypes: [],
      appointment: '',
      checked: true,
      activeTab3: "7",
      deal: '',
      activeCategories: {},
      dealType: "",
      statusType: "",
      showCard: false,
      expandedRows: null,
      filters: {
        type: { value: null, matchMode: FilterMatchMode.CUSTOM },
        status: { value: null, matchMode: FilterMatchMode.CUSTOM }
      },
    }
    this.toggleAddNew = this.toggleAddNew.bind(this);
    this.toggleManage = this.toggleManage.bind(this);
    this.toggleManage2 = this.toggleManage2.bind(this);
    this.toggle3 = this.toggle3.bind(this);
    this.deleteDeal = this.deleteDeal.bind(this);
    this.handleDocumentSubmit = this.handleDocumentSubmit.bind(this)
  }
  toggleCard = (value) => {
    this.setState({ showCard: value });
  };
  toggleCategory = (category) => {
    this.setState((prevState) => ({
      activeCategories: {
        ...prevState.activeCategories,
        [category]: !prevState.activeCategories[category],
      },
    }));
  };
  handleDocumentSubmit(value) {
    const payload = {
      clientEngagementId: parseInt(value.clientEngagementId),
      agreementDocumentFromId: parseInt(value.agreementDocumentFromId),
      agreementDocumentToId: parseInt(value.agreementDocumentToId),
      agreementDocumentTitle: value.agreementDocumentTitle,
      agreementDocumentFrom: value.agreementDocumentFrom,
      agreementDocumentTo: value.agreementDocumentTo,
      agreementDocumentLink: value.agreementDocumentLink,
      agreementDocumentStorageType: parseInt(value.agreementDocumentStorageType),
      agentId: parseInt(value.agentId),
      isActive: true,
      isUrgent: false,
      sendNotification: false
    }
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}ClientAgreementDocument`;
    toast.loading("Please wait...");
    axios
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.dismiss();
          toast.success("Saved successfully!");
          this.setState({ fileUploaded: false });
          this.fetchDealdocument(value.clientEngagementId);

        } else {
          toast.dismiss();
          toast.error('some issue while uploading document');
          console.warn("Submission failed:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error submitting document:", error);

      });
  }

  fetchBuyerDealChecklist(clientType, dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      DealId: dealId,
      ClientTypeId: clientType,
      ClientId: this.props.match.params.id,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientBuyerClosingCheckList/allfordeal`, { headers, params })
      .then((response) => {
        const fetchedSelectedTasks = response.data.map(
          (task) => task.clientClosingCheckListId
        );
        this.setState({
          dealChecklists: response.data,
          selectedChecklistIds: fetchedSelectedTasks,
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }


  fetchDealdocument(dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      EngagementId: dealId,
      ClientId: this.props.match.params.id,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientAgreementDocument/allbyDeal`, { headers, params })
      .then((response) => {
        this.setState({ dealDocuments: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }



  async handleFileChange(event, setFieldValue) {
    const file = event.currentTarget.files[0];
    if (file) {
      const maxSize = 5 * 1024 * 1024;
      const allowedTypes = ['application/pdf', 'application/msword', 'image/jpeg', 'image/png'];
      const allowedExtensions = ['.pdf', '.doc', '.jpg', '.jpeg', '.png', '.webp'];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
      if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
        Swal.fire({
          title: 'File type or extension not allowed',
          text: 'Please upload a PDF, DOC, JPG, or PNG file.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
        return;
      }
      if (file.size > maxSize) {
        Swal.fire({
          title: 'Size not allowed',
          text: 'Please Upload Maximum 5MB File',
          icon: 'warning',
          confirmButtonText: 'OK',
        });

      }
      this.setState({ btnloading: true });
      const sasToken = azureConfig.sasToken;
      const containerName = azureConfig.containerName;
      const storageAccountName = azureConfig.storageAccountName;
      const fileName = `${Date.now()}_${file.name}`;
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
      );
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlockBlobClient(fileName);

      try {
        await blobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type }
        });


        if (setFieldValue) {
          const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
          setFieldValue(`agreementDocumentLink`, fileUrl);
          //setFieldValue(`agreementDocumentTitle`, fileUrl);
          this.setState({ fileUploaded: true });
        }
      } catch (error) {
        console.error('Error uploading file:', error);

      }
    }
  }
  deleteDeal = (deal) => {
    this.setState({ deal: deal });
    this.setState({ deleteModal: true });
  };
  handleDeleteDeal = () => {
    const { onDeleteDeal } = this.props;
    const { deal } = this.state;
    const deletePayload = {
      id: deal.clientEngagementId,
      agentId: localStorage.getItem("userId"),
      clientId: this.props.match.params.id,
    };
    onDeleteDeal(deletePayload);
    this.setState({ deleteModal: false });
    this.toggle();

  };
  getBuyerType = (type) => {
    if (type == 1)
      return 'Rent';
    else if (type == 2)
      return 'Purchase';

  }

  getSellerType = (type) => {
    if (type == 1)
      return 'Sell';
    else if (type == 2)
      return 'Lease';

  }
  getCommType = (type) => {
    if (type == 3)
      return 'Fixed';
    else if (type == 4)
      return 'Percentage';

  }
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });
  }
  toggle() {
    this.setState(prevState => ({
      isManage: !prevState.isManage,
      activeTab3: !prevState.isRight ? "7" : prevState.activeTab3,
    }));
  }
  toggle2() {
    this.setState(prevState => ({
      isManage2: !prevState.isManage2
    }));
  }
  fetchMortgageContact(dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      dealId: dealId,
      agentId: localStorage.getItem("userId"),
      clientId: this.props.match.params.id
    };
    axios
      .get(`${API_URL}ClientProfessionalContactExt/get_client_mortgage_contactdeal`, { headers, params })
      .then((response) => {
        this.setState({ mortgageContact: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  fetchLegalContact(dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      dealId: dealId,
      agentId: localStorage.getItem("userId"),
      clientId: this.props.match.params.id
    };
    axios
      .get(`${API_URL}ClientProfessionalContactExt/get_client_legal_contactdeal`, { headers, params })
      .then((response) => {
        this.setState({ legalContact: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchSellerChecklist(dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      DealId: dealId,
      ClientTypeId: 2,
      ClientId: this.props.match.params.id,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientSellerClosingCheckList/allfordeal`, { headers, params })
      .then((response) => {
        const fetchedSelectedTasks = response.data.map(
          (task) => task.clientClosingCheckListId
        );
        this.setState({
          dealChecklists: response.data,
          selectedChecklistIds: fetchedSelectedTasks,
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }


  fetchBuyerClosingChecklist() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      forType: 1,
      agentId: localStorage.getItem("userId"),
      propertyType: 0
    };
    axios
      .get(`${API_URL}ClientClosingCheckList/allforagenttype`, { headers, params })
      .then((response) => {
        this.setState({ closingChecklist: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchSellerClosingChecklist() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      forType: 2,
      agentId: localStorage.getItem("userId"),
      propertyType: 0
    };
    axios
      .get(`${API_URL}ClientClosingCheckList/allforagenttype`, { headers, params })
      .then((response) => {
        this.setState({ closingChecklist: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  componentDidMount() {
    const { match: { params }, onGetClientDetail, onGetClientDeals, onGetListingType, onGetUserDetail } = this.props;
    onGetClientDetail(params.clientId);
    onGetClientDeals(localStorage.getItem('userId'), params.id)
    onGetListingType(localStorage.getItem('userId'))
    onGetUserDetail(localStorage.getItem('userId'))
    //this.fetchBuyerClosingChecklist();
    //this.fetchSellerClosingChecklist();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { deals } = this.props;
    if (!isEmpty(deals) && size(prevProps.deals) !== size(deals)) {
      this.setState({ deals: {}, isEdit: false });
    }
  }
  toggleManage() {
    this.setState({ deal: "", isEdit: false, isManage: !this.state.isManage, activeTab3: "7" });
    this.toggle();
  }


  toggleManage2() {
    this.setState({ deal: "", isManage2: !this.state.isManage2 });
    this.toggle2();
  }


  fetchBuyerListing(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    axios
      .get(`${API_URL}AgentClientPotentialListing/${listingId}`, { headers })
      .then((response) => {
        this.setState({ buyerListing: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchSellerListing(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    axios
      .get(`${API_URL}ClientSellerShowing/byid?sellerShowingId=${listingId}`, { headers })
      .then((response) => {
        this.setState({ sellerListing: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchInvestorListing(listingId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    const params = {
      agentId: localStorage.getItem("userId"),
      clientId: this.props.match.params.id,
      selectedOptionId: listingId
    };
    axios
      .get(`${API_URL}ProjectCampaignClient/projectselectedoption`, { headers, params })
      .then((response) => {
        this.setState({ investorListing: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  toggleManage = arg => {
    const deal = arg;

    this.setState({
      deal: {
        id: deal.id,
        clientEngagementId: deal.id,
        clientEngagementGuId: deal.clientEngagementId,
        contactName: deal.contactName,
        contactAddress: deal.contactAddress,
        clientEngagementStatus: deal.clientEngagementStatus,
        commissionTypeId: deal.commissionTypeId,
        commissionValue: deal.commissionValue,
        closingDate: deal.closingDate,
        startDate: deal.startDate,
        endDate: deal.endDate,
        propertyAddress: deal.propertyAddress,
        transactionAmount: deal?.transactionAmount,
        commissionValue: deal?.commissionValue,
        lastAgreementDate: deal?.lastAgreementDate,
        isBuyer: deal?.isBuyer,
        isSeller: deal?.isSeller,
        isInvestor: deal?.isInvestor,
        buyerType: deal?.buyerType,
        sellerType: deal?.sellerType,

        agentName: deal?.agentName,
        agentOfficeName: deal?.agentOfficeName,
        agentMobile: deal?.agentMobile,
        agentEmail: deal?.agentEmail,
        clientName: deal?.clientName,
        clientMobile: deal?.clientMobile,
        clientEmail: deal?.clientEmail,
        clinetPhone: deal?.clientPhone,
        secondaryClientName: deal?.secondaryClientName,
        secondaryClientEmail: deal?.secondaryClientEmail,
        secondaryClientMobile: deal?.secondaryClientMobile,
        secondaryClientPhone: deal?.secondaryClientPhone,
        dealRefId: deal?.dealRefId,
        currencyCode: deal?.currencyCode
      },
      isEdit: true,
    });
    this.fetchMortgageContact(deal.id);
    this.fetchLegalContact(deal.id);
    this.fetchDealdocument(deal.id);
    if (deal.isBuyer) {
      this.fetchBuyerClosingChecklist()
      this.fetchBuyerDealChecklist(1, deal.id);
      this.fetchBuyerListing(deal.dealRefId);
      this.fecthBuyerDealChecklist();
      this.fecthBuyerDealSelectedChecklist(deal.id);
      this.GetBuyerClientOffersByDealId(deal.id);
    } else if (deal.isSeller) {
      this.fetchSellerClosingChecklist();
      this.fetchSellerChecklist(deal.id);
      this.fetchSellerListing(deal.dealRefId);
      this.fecthSellerDealChecklist();
      this.fecthSellerDealSelectedChecklist(deal.id);
      this.GetSellerClientOffersByDealId(deal.id);
    } else if (deal.isInvestor) {
      this.fetchInvestorListing(deal.dealRefId);
    }
    this.toggle();

  };
  toggleManage2 = arg => {
    const deal = arg;

    this.setState({
      deal: {
        id: deal.id,
        cancellationFellThroughDate: deal.cancellationFellThroughDate,
        cancellationFellThroughNotes: deal.cancellationFellThroughNotes
      },

    });
    this.toggle2();

  };
  handleDeleteDoc = (doc) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        axios
          .delete(`${API_URL}ClientAgreementDocument/${doc.id}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            Swal.fire("Deleted!", "The document has been deleted.", "success");
            this.setState((prevState) => ({
              dealDocuments: prevState.dealDocuments.filter((d) => d.id !== doc.id),
            }));
          })
          .catch((error) => {
            Swal.fire("Error!", "An error occurred while deleting the document.", "error");
          });
      }
    });
  }
  groupByCategory = (list) => {
    return list.reduce((acc, item) => {
      if (!acc[item.checkListCategory]) {
        acc[item.checkListCategory] = [];
      }
      acc[item.checkListCategory].push(item);
      return acc;
    }, {});
  };
  handleDealTypeChange = (e) => {
    this.setState({ dealType: e.target.value });
  };
  handleStatusTypeChange = (e) => {
    this.setState({ statusType: e.target.value });
  };
  getFilteredDeals = () => {
    const { dealType } = this.state;
    const { deals } = this.props;
    if (dealType === "") return deals;

    return deals.filter((deal) => {
      switch (dealType) {
        case "0": return deal.isBuyer && deal.buyerType === 2;
        case "1": return deal.isBuyer && deal.buyerType === 1;
        case "2": return deal.isSeller && deal.sellerType === 1;
        case "3": return deal.isSeller && deal.sellerType === 2;
        case "4": return deal.isInvestor;
        default: return true;
      }
    });
  };
  getFilteredDeals_new = () => {
    const { dealType, statusType } = this.state;
    const safeDeals = Array.isArray(this.props.deals)
      ? this.props.deals
      : this.props.deals
        ? [this.props.deals]
        : [];

    if (dealType === "" && statusType === "") {
      return safeDeals;
    }

    return safeDeals.filter((deal) => {
      let dealTypeMatch = true;
      if (dealType !== "") {
        switch (dealType) {
          case "0": dealTypeMatch = deal.isBuyer && deal.buyerType === 2; break;
          case "1": dealTypeMatch = deal.isBuyer && deal.buyerType === 1; break;
          case "2": dealTypeMatch = deal.isSeller && deal.sellerType === 1; break;
          case "3": dealTypeMatch = deal.isSeller && deal.sellerType === 2; break;
          case "4": dealTypeMatch = deal.isInvestor; break;
          default: dealTypeMatch = true;
        }
      }

      let statusMatch = true;
      if (statusType !== "") {
        statusMatch = String(deal.clientEngagementStatus) === statusType;
      }

      return dealTypeMatch && statusMatch;
    });
  };
  handleEditPlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;

        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };
        setFieldValue('contactAddress', place.formatted_address);
        //setFieldValue('listingCity', getComponent(['locality', 'political']));
      })
      .catch(error => console.error('Error', error));
  };

  fecthBuyerDealChecklist = () => {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) return;
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;
    if (!token) return;
    const str = 'Bearer ' + token;
    axios.get(`${API_URL}ClientDealCheckList/allforagenttype`, {
      params: {
        agentId: parseInt(localStorage.getItem("userId")),
        forType: 1
      },
      headers: { Authorization: str }
    })
      .then(res => this.setState({ alldealChecklists: res.data }))
      .catch(err => console.error("Error fetching templates:", err));
  }
  fecthSellerDealChecklist = () => {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) return;
    const obj = JSON.parse(authUser);
    const token = obj?.resultData?.bearerToken;
    if (!token) return;
    const str = 'Bearer ' + token;
    axios.get(`${API_URL}ClientDealCheckList/allforagenttype`, {
      params: {
        agentId: parseInt(localStorage.getItem("userId")),
        forType: 2
      },
      headers: { Authorization: str }
    })
      .then(res => this.setState({ alldealChecklists: res.data }))
      .catch(err => console.error("Error fetching templates:", err));
  }

  fecthBuyerDealSelectedChecklist(dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      DealId: dealId,
      ClientTypeId: 1,
      ClientId: this.props.match.params.id,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientBuyerDealCheckList/allfordeal`, { headers, params })
      .then((response) => {

        this.setState({
          newdealChecklists: response.data,
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }


  fecthSellerDealSelectedChecklist(dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      DealId: dealId,
      ClientTypeId: 2,
      ClientId: this.props.match.params.id,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientSellerDealCheckList/allfordeal`, { headers, params })
      .then((response) => {

        this.setState({
          newdealChecklists: response.data,
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fecthSellerDealSelectedChecklist_old(dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      DealId: dealId,
      ClientTypeId: 2,
      ClientId: this.props.match.params.id,
      AgentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientSellerDealCheckList/allfordeal`, { headers, params })
      .then((response) => {

        this.setState({
          newdealChecklists: response.data,
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }


  GetSellerClientOffersByDealId(dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      dealId: dealId,
    };
    axios
      .get(`${API_URL}ClientOffer/GetSellerClientOffersByDealId`, { headers, params })
      .then((response) => {
        const offers = response.data;
        this.setState({
          clientSellerOffer: Array.isArray(offers) && offers.length > 0 ? offers[0] : {},
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  GetBuyerClientOffersByDealId(dealId) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      dealId: dealId,
    };
    axios
      .get(`${API_URL}ClientOffer/GetBuyerClientOffersByDealId`, { headers, params })
      .then((response) => {
        const offers = response.data;
        this.setState({
          clientBuyerOffer: Array.isArray(offers) && offers.length > 0 ? offers[0] : {},
          loading: false
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  handleFellThroughSubmit = async (values) => {
    const { onGetClientDeals } = this.props;
    const payload = {
      clientEngagementForId: parseInt(values.clientEngagementForId),
      clientEngagementGuId: values.clientEngagementGuId,
      fellThroughDate: values.cancellationDate,
      notes: values.notes,
      agentId: parseInt(localStorage.getItem('userId')),
      clientId: parseInt(this.props.match.params.id)
    }

    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      toast.loading("Please wait...");
      const response = await axios.post(
        `${API_URL}ClientEngagement/FellThroughClientDeal`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data?.success === true) {
        toast.dismiss();
        toast.success("Saved successfully!");
        this.toggleCard(false);
        onGetClientDeals(localStorage.getItem('userId'), this.props.match.params.id)
        this.toggle();
      } else {
        toast.error(
          `Failed: ${response.data?.message || "Unknown error occurred"}`
        );
      }
    } catch (error) {
      toast.dismiss();
      toast.error(
        `Error marking deal as Fell Through: ${error.response?.data?.message || error.message
        }`
      );
      console.error("Error:", error);
    }
  }
  handleCancelSubmit = async (values) => {
    const { onGetClientDeals } = this.props;
    const payload = {
      clientEngagementForId: parseInt(values.clientEngagementForId),
      clientEngagementGuId: values.clientEngagementGuId,
      cancellationDate: values.cancellationDate,
      notes: values.notes,
      agentId: parseInt(localStorage.getItem('userId')),
      clientId: parseInt(this.props.match.params.id)
    }

    try {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      toast.loading("Please wait...");
      const response = await axios.post(
        `${API_URL}ClientEngagement/CancelClientDeal`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data?.success === true) {
        toast.dismiss();
        toast.success("Saved successfully!");
        this.toggleCard(false);
        onGetClientDeals(localStorage.getItem('userId'), this.props.match.params.id)
        this.toggle();
      } else {
        toast.error(
          `Failed: ${response.data?.message || "Unknown error occurred"}`
        );
      }
    } catch (error) {
      toast.dismiss();
      toast.error(
        `Error marking deal as Fell Through: ${error.response?.data?.message || error.message
        }`
      );
      console.error("Error:", error);
    }
  }
  getStatus = (status) => {
    if (status == 1)
      return 'In-progress';
    else if (status == 2)
      return 'Completed';
    else if (status == 3)
      return 'Cancelled';
    else if (status == 4)
      return 'Fell through ';
    else
      return 'Pending';

  }

   handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        console.log(modifiedAddress)
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };
  handleSubmitLowyer = async (values, { setSubmitting, resetForm }) => {
  try {
    const payload = {
        id:values.id,
        clientProfessionalContactId:values.clientProfessionalContactId || '3f9432c8-2c15-46c9-81f7-aff0552eb84a',
        primaryContactId:values.primaryContactId || 0,
        addressId:values.addressId || 0,
        isActive:true,
        dealId: values.dealId,
        title:values.title,
        notes:values.notes,
        professionalContactTypeId: values.professionalContactTypeId,
        contactFName: values.contactFName,
        contactLName: values.contactLName,
        contactName: `${values.contactFName} ${values.contactLName}`,
        clientId: parseInt(values.clientId),
        agentId: parseInt(values.agentId),
        organizationName: values.organizationName,
        email: values.email,
        phone: values.phone,
        mobile: values.mobile,
       
        fullAddress:values.fullAddress,
        addressLine1:values.addressLine1,
        addressLine2:values.addressLine2,
        nearestIntersection:values.nearestIntersection,
        city:values.city,
        province:values.province,
        postal:values.postal,
        country:values.country,
        longitude:values.longitude,
        latitude:values.latitude,   
    }
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const apiUrl = values.id !== 0
    ? `${API_URL}ClientProfessionalContactExt/update_client_legal_contact`
    : `${API_URL}ClientProfessionalContactExt/add_client_legal_contact`;
toast.loading("Please wait...");
  const method = values.id !== 0 ? "put" : "post";
  const response = await axios({
    method,
    url: apiUrl,
    data: payload,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
    if (response.status === 200 || response.status === 201) {
      toast.dismiss();
      toast.success("Updated successfully");
      this.toggle();
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    
  } finally {
    setSubmitting(false);
  }
  };
  handleSubmitMortgage = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
          id:values.id,
          clientProfessionalContactId:values.clientProfessionalContactId || '3f9432c8-2c15-46c9-81f7-aff0552eb84a',
          primaryContactId:values.primaryContactId || 0,
          addressId:values.addressId || 0,
          isActive:true,
          dealId: values.dealId,
          title:values.title,
          notes:values.notes,
          professionalContactTypeId: values.professionalContactTypeId,
          contactFName: values.contactFName,
          contactLName: values.contactLName,
          contactName: `${values.contactFName} ${values.contactLName}`,
          clientId: parseInt(values.clientId),
          agentId: parseInt(values.agentId),
          organizationName: values.organizationName,
          email: values.email,
          phone: values.phone,
          mobile: values.mobile,
         
          fullAddress:values.fullAddress,
          addressLine1:values.addressLine1,
          addressLine2:values.addressLine2,
          nearestIntersection:values.nearestIntersection,
          city:values.city,
          province:values.province,
          postal:values.postal,
          country:values.country,
          longitude:values.longitude,
          latitude:values.latitude,   
      }
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const apiUrl = values.id !== 0
      ? `${API_URL}ClientProfessionalContactExt/update_client_mortgage_contact`
      : `${API_URL}ClientProfessionalContactExt/add_client_mortgage_contact`;

    toast.loading("Please wait...");
    const method = values.id !== 0 ? "put" : "post";
    const response = await axios({
      method,
      url: apiUrl,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
      if (response.status === 200 || response.status === 201) {
      toast.dismiss();
      toast.success("Updated successfully");
      this.toggle();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      
    } finally {
      setSubmitting(false);
    }
  };
  render() {
    const { clietDetail, loading, deals, listingtypes, userdetail, isResponsive } = this.props;
    const { deal, deleteModal, closingChecklist, fileUploaded, mortgageContact, legalContact, dealDocuments,
      dealChecklists, buyerListing, sellerListing, investorListing, newdealChecklists, clientSellerOffer, clientBuyerOffer } = this.state;
    //const groupedChecklist = dealChecklists ? this.groupByCategory(dealChecklists) : [];
    const { showCard } = this.state;
    const groupedChecklist = closingChecklist?.reduce((acc, item) => {
      acc[item.checkListCategory] = acc[item.checkListCategory] || [];
      acc[item.checkListCategory].push(item);
      return acc;
    }, {});
    const startDate = deal?.lastAgreementDate ? new Date(deal?.lastAgreementDate) : null;
    const formattedDate = startDate
      ? `${startDate.getFullYear().toString().slice(-2)}${(startDate.getMonth() + 1).toString().padStart(2, '0')}`
      : "";
    const generatedDealId = deal?.id ? `${deal?.id}-${formattedDate}` : "";


    const { dealType, statusType } = this.state;
    let filteredDeals = Array.isArray(deals) ? deals : deals ? [deals] : [];
    if (dealType !== "") {
      filteredDeals = filteredDeals.filter((d) => {
        if (dealType === "0" && d.isBuyer && d.buyerType === 1) return true; // Buyer - Purchase
        if (dealType === "1" && d.isBuyer && d.buyerType === 2) return true; // Buyer - Rent
        if (dealType === "2" && d.isSeller && d.sellerType === 1) return true; // Seller - Sell
        if (dealType === "3" && d.isSeller && d.sellerType === 2) return true; // Seller - Lease
        if (dealType === "4" && d.isInvestor) return true; // Investor
        return false;
      });
    }
    if (statusType !== "") {
      filteredDeals = filteredDeals.filter(
        (d) => String(d.clientEngagementStatus) === statusType
      );
    }

    //console.log(investorListing);
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteDeal}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="ps-0 pe-0">
                <Row className="project-header">
                  <Col sm="7">
                    <ClientDealBreadcrumbs
                      title={this.props.t("Clients")}
                      breadcrumbItem={this.props.t(" Deal")}
                    />
                  </Col>
                  <Col sm="4" className="">
                    <h2 className="">{this.props.t(clietDetail.firstName + " " + clietDetail.lastName)}</h2>

                  </Col>
                </Row>

                <Row>


                  <Col xl="12">

                    <Row>
                      <Col sm="12">
                        <Card>
                          <CardBody>
                            <Row className="mb-2">

                              <Col xs="6" sm="2">
                                <select className="form-select select-filter" value={this.state.dealType} onChange={this.handleDealTypeChange}>
                                  <option value="">All Deals</option>
                                  <option value="0">Buyer - Purchase</option>
                                  <option value="1">Buyer - Rent </option>
                                  <option value="2">Seller - Sell </option>
                                  <option value="3">Seller - Lease</option>
                                  <option value="4">Investor</option>

                                </select>
                              </Col>
                              <Col xs="6" sm="2">
                                <select className="form-select select-filter" value={this.state.statusType} onChange={this.handleStatusTypeChange}>
                                  <option value="">All Status</option>
                                  <option value="0">New</option>
                                  <option value="1">In-progress </option>
                                  <option value="2">Completed </option>
                                  <option value="3">Cancelled</option>
                                  <option value="4">Fell Through</option>

                                </select>
                              </Col>
                              <Col xs="12" sm="8">
                                <span
                                  className={`d-block ${isResponsive ? "mt-2 float-end" : "float-end me-2"}`}
                                >
                                  <RsAdNew onClick={this.toggleAddNew}>Add New</RsAdNew>
                                </span>
                              </Col>
                            </Row>
                            {isResponsive ? (
                              <DataTable
                              value={filteredDeals}
                              dataKey="id"
                              responsiveLayout="stack"
                              expandedRows={this.state.expandedRows}
                              onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                              paginator rows={10}
                              rowExpansionTemplate={(rowData) => (
                                <table className="table table-bordered mb-0">
                                  <tbody>
                                    <tr><th>Agreement Date</th><td>{rowData.lastAgreementDate ? <Moment format="MMM, DD YYYY">{rowData.lastAgreementDate}</Moment> : "N/A"}</td></tr>
                                    <tr><th>Type</th><td>{rowData.isBuyer ? `Buyer - ${this.getBuyerType(rowData.buyerType)}` : rowData.isSeller ? `Seller - ${this.getSellerType(rowData.sellerType)}` : "N/A"}</td></tr>
                                   <tr>
                                        <th>Transaction Amount</th>
                                        <td>
                                          {(() => {
                                            const amount = rowData?.transactionAmount;

                                            if (!amount || Number(amount) === 0) {
                                              return "N/A";
                                            }

                                            return (
                                              <CurrencyFormat
                                                value={amount}
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                prefix={rowData.currencyCode ? rowData.currencyCode + " " : "$"}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                              />
                                            );
                                          })()}
                                        </td>
                                      </tr>
                                        <tr>
                                        <th>Commission Type</th>
                                        <td>
                                          {this.getCommType(rowData.commissionTypeId) || "N/A"}
                                        </td>
                                      </tr>
                                       <tr>
                                        <th>Commission Value</th>
                                        <td>
                                          {(() => {
                                              if (rowData.commissionTypeId === 3) {
                                                return `$${rowData.commissionValue?.toFixed(2) || "0.00"}`;
                                              }
                                              if (rowData.commissionTypeId === 4) {
                                                return `${rowData.commissionValue?.toFixed(2) || "0.00"} %`;
                                              }
                                          })()}
                                        </td>
                                      </tr>
                                    <tr><th>Status</th> <td>
                                      {(() => {
                                        switch (rowData.clientEngagementStatus) {
                                          case 0:
                                            return <span className="btnOfferRecieved">New</span>
                                          case 1:
                                            return <span className="btnOfferRecieved">In-progress</span>
                                          case 2:
                                            return <span className="btnOfferAccepted">Completed</span>
                                          case 3:
                                            return <span className="btnOfferWithdrawn">Cancelled</span>
                                          case 4:
                                            return <span className="btnOfferRejected">Fell Through</span>
                                          default:
                                            return <span>N/A</span>
                                        }
                                      })()}
                                    </td></tr>
                                    <tr><th>Action</th><td><button className="btn btn-action" onClick={() => this.toggleManage(rowData)}>Manage</button></td></tr>
                                  </tbody>
                                </table>
                              )}
                            >
                              <Column expander style={{ width: '3em' }} />
                              <Column
                                header="#"
                                body={(rowData, options) => options.rowIndex + 1}
                                style={{ width: '60px'}}
                              />
                              <Column header="Date" body={(rowData) => (
                                <div>
                                  <strong>{rowData.clientName}</strong>
                                  <div className="text-muted">{rowData.lastAgreementDate ? <Moment format="MMM DD">{rowData.lastAgreementDate}</Moment> : 'N/A'}</div>
                                </div>
                              )} />
                              <Column field="clientName" header="Deal Id"
                                body={(rowData) => {
                                  const id = rowData.id || "N/A";
                                  const date = rowData.lastAgreementDate ? new Date(rowData.lastAgreementDate) : null;
                                  const formattedDate = date
                                    ? `${String(date.getFullYear()).slice(2)}${String(date.getMonth() + 1).padStart(2, "0")}`
                                    : "0000";
                                  return `${id}-${formattedDate}`;
                                }}
                              />

                              <Column
                                header="Type"

                                body={(rowData) => {
                                  if (rowData.isBuyer)
                                    return `Buyer${rowData.buyerType ? ` - ${this.getBuyerType(rowData.buyerType)}` : ""
                                      }`;
                                  if (rowData.isSeller)
                                    return `Seller${rowData.sellerType ? ` - ${this.getSellerType(rowData.sellerType)}` : ""
                                      }`;
                                  if (rowData.isInvestor) return "Investor";
                                  return "N/A";
                                }}
                              />

                                <Column
                                field="action"
                                header="Action"
                                body={(rowData) => {
                                  switch (rowData.clientEngagementStatus) {
                                    case 3:
                                      return (
                                        <Link
                                          to="#"
                                          onClick={() => this.toggleManage2(rowData)}
                                          className="btn btn-action"
                                        >
                                          Manage
                                        </Link>
                                      );
                                    case 4:
                                      return (
                                        <Link
                                          to="#"
                                          onClick={() => this.toggleManage2(rowData)}
                                          className="btn btn-action"
                                        >
                                          Manage
                                        </Link>
                                      );
                                    case 4:
                                      return (
                                        <Link
                                          to="#"
                                          onClick={() => this.toggleManage2(rowData)}
                                          className="btn btn-action"
                                        >
                                          Manage
                                        </Link>
                                      );
                                    default:
                                      return rowData.clientEngagementStatus > 0 ? (
                                        <Link
                                          to="#"
                                          onClick={() => this.toggleManage(rowData)}
                                          className="btn btn-action"
                                        >
                                          Manage
                                        </Link>
                                      ) : (
                                        <Link
                                          to="#"
                                          onClick={() => this.toggleManage(rowData)}
                                          className="btn btn-action"
                                        >
                                          Manage
                                        </Link>
                                      );
                                  }
                                }}
                              />

                            </DataTable>
                            ):(
                                 <DataTable
                              className=""


                              value={filteredDeals}

                              paginator
                              rows={10}
                              rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
                              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              tableStyle={{ minWidth: "50rem" }}



                            >
                               <Column
                                header="#"
                                body={(rowData, options) => options.rowIndex + 1}
                                style={{ width: '60px'}}
                              />
                              <Column
                                field="lastAgreementDate"
                                header="Agreement Date"
                                body={(rowData) =>
                                  rowData.lastAgreementDate ? <Moment format="MMM, DD YYYY">{rowData.lastAgreementDate}</Moment> : "N/A"
                                }
                              />

                              <Column field="clientName" header="Deal Id"
                                body={(rowData) => {
                                  const id = rowData.id || "N/A";
                                  const date = rowData.lastAgreementDate ? new Date(rowData.lastAgreementDate) : null;
                                  const formattedDate = date
                                    ? `${String(date.getFullYear()).slice(2)}${String(date.getMonth() + 1).padStart(2, "0")}`
                                    : "0000";
                                  return `${id}-${formattedDate}`;
                                }}
                              />
                              {/* <Column field="contactName" header="Type" body={(rowData) => {
                                if (rowData.isBuyer) return `Buyer ${rowData.buyerType ? `- ${this.getBuyerType(rowData.buyerType)}` : ""}`;
                                if (rowData.isSeller) return `Seller ${rowData.sellerType ? `- ${this.getSellerType(rowData.sellerType)}` : ""}`;
                                if (rowData.isInvestor) return "Investor";
                                return "N/A";
                              }} /> */}


                              <Column
                                header="Type"

                                body={(rowData) => {
                                  if (rowData.isBuyer)
                                    return `Buyer${rowData.buyerType ? ` - ${this.getBuyerType(rowData.buyerType)}` : ""
                                      }`;
                                  if (rowData.isSeller)
                                    return `Seller${rowData.sellerType ? ` - ${this.getSellerType(rowData.sellerType)}` : ""
                                      }`;
                                  if (rowData.isInvestor) return "Investor";
                                  return "N/A";
                                }}
                              />


                              <Column
                                field="transactionAmount"
                                header="Transaction Amount"
                                body={(rowData) => {
                                  const amount = rowData?.transactionAmount;

                                  if (!amount || Number(amount) === 0) {
                                    return "N/A";
                                  }

                                  return (
                                    <CurrencyFormat
                                      value={amount}
                                      displayType={"text"}
                                      thousandSeparator={true}
                                      prefix={rowData.currencyCode ? rowData.currencyCode + " " : "$"}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                    />
                                  );
                                }}
                              />
                              {/* <Column field="transactionAmount" header="Transaction Amount" body={(rowData) => `$${rowData?.transactionAmount?.toFixed(2) || "0.00"}`} /> */}
                              <Column field="commissionTypeId" header="Commission Type" body={(rowData) => this.getCommType(rowData.commissionTypeId) || "N/A"} />
                              <Column field="commissionValue" header="Commission Value" body={(rowData) => {
                                if (rowData.commissionTypeId === 3) {
                                  return `$${rowData.commissionValue?.toFixed(2) || "0.00"}`;
                                }
                                if (rowData.commissionTypeId === 4) {
                                  return `${rowData.commissionValue?.toFixed(2) || "0.00"} %`;
                                }
                              }}

                              />
                              {/* <Column
                                field="clientEngagementStatus"
                                header="Status"
                                body={(rowData) => {
                                  switch (rowData.clientEngagementStatus) {
                                    case 0:
                                      return <span className="btnOfferRecieved">New</span>;
                                    case 1:
                                      return <span className="btnOfferRecieved">In-progress</span>;
                                    case 2:
                                      return <span className="btnOfferAccepted">Completed</span>;
                                    case 3:
                                      return <span className="btnOfferWithdrawn">Cancelled</span>;
                                    case 4:
                                      return <span className="btnOfferRejected">Fell Through</span>;
                                    default:
                                      return <span>N/A</span>;
                                  }
                                }}
                              /> */}
                              <Column
                                field="clientEngagementStatus"
                                header="Status"

                                body={(rowData) => {
                                  switch (rowData.clientEngagementStatus) {
                                    case 0:
                                      return <span className="btnOfferRecieved">New</span>;
                                    case 1:
                                      return <span className="btnOfferRecieved">In-progress</span>;
                                    case 2:
                                      return <span className="btnOfferAccepted">Completed</span>;
                                    case 3:
                                      return <span className="btnOfferWithdrawn">Cancelled</span>;
                                    case 4:
                                      return <span className="btnOfferRejected">Fell Through</span>;
                                    default:
                                      return <span>N/A</span>;
                                  }
                                }}
                              />
                              {/* <Column
                                field="action"
                                header="Action"
                                body={(rowData) => (
                                  rowData.clientEngagementStatus > 0 ? (
                                    <Link
                                      to="#"
                                      onClick={() => this.toggleManage(rowData)}
                                      className="btn btn-action"
                                    >
                                      Manage
                                    </Link>
                                  ) : (
                                    <Link
                                      to="#"
                                      onClick={(e) => e.preventDefault()}
                                      className="btn btn-action disabled"
                                    >
                                      Manage
                                    </Link>
                                  )
                                )}
                              /> */}
                              <Column
                                field="action"
                                header="Action"
                                body={(rowData) => {
                                  switch (rowData.clientEngagementStatus) {
                                    case 3:
                                      return (
                                        <Link
                                          to="#"
                                          onClick={() => this.toggleManage2(rowData)}
                                          className="btn btn-action"
                                        >
                                          Manage
                                        </Link>
                                      );
                                    case 4:
                                      return (
                                        <Link
                                          to="#"
                                          onClick={() => this.toggleManage2(rowData)}
                                          className="btn btn-action"
                                        >
                                          Manage
                                        </Link>
                                      );
                                    case 4:
                                      return (
                                        <Link
                                          to="#"
                                          onClick={() => this.toggleManage2(rowData)}
                                          className="btn btn-action"
                                        >
                                          Manage
                                        </Link>
                                      );
                                    default:
                                      return rowData.clientEngagementStatus > 0 ? (
                                        <Link
                                          to="#"
                                          onClick={() => this.toggleManage(rowData)}
                                          className="btn btn-action"
                                        >
                                          Manage
                                        </Link>
                                      ) : (
                                        <Link
                                          to="#"
                                          onClick={() => this.toggleManage(rowData)}
                                          className="btn btn-action"
                                        >
                                          Manage
                                        </Link>
                                      );
                                  }
                                }}
                              />

                            </DataTable>
                            )}
                            
                           

                          </CardBody>
                        </Card>
                      </Col>
                    </Row>


                  </Col>

                </Row>
              </Col>
            </Row>
            <Offcanvas
              isOpen={this.state.isAddNew}
              direction="end"
              toggle={this.toggleAddNew}
              style={{ width: "600px" }}
            >
              <OffcanvasHeader toggle={this.toggleAddNew}>
                New Deal
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{

                    contactName: clietDetail.firstName + " " + clietDetail.lastName,
                    contactAddress: clietDetail?.clientAddress?.fullAddress,
                    clientId: clietDetail.id,
                    isBuyer: false,
                    isSeller: false,
                    isInvestor: false,
                    buyerType: '',
                    sellerType: '',
                    agentId: localStorage.getItem('userId'),
                    clientStatusId: clietDetail.clientStatusId,
                    clientEngagementStatus: 1,
                    commissionTypeId: '',
                    commissionValue: '',
                    lastAgreementDate: new Date(),
                    sellerCommissionTypeId: '',
                    sellerCommissionValue: '',
                    sellerLastAgreementDate: new Date(),
                    investorLastAgreementDate: new Date(),
                    startDate: null,
                    endDate: null,
                    sellerStartDate: null,
                    sellerEndDate: null,

                  }}
                  validationSchema={Yup.object().shape({
                    isBuyer: Yup.boolean(),
                    isSeller: Yup.boolean(),
                    isInvestor: Yup.boolean(),
                    buyerType: Yup.string().when("isBuyer", {
                      is: true,
                      then: Yup.string().required("Buyer type is required"),
                      otherwise: Yup.string().nullable(),
                    }),
                    commissionTypeId: Yup.string().when("isBuyer", {
                      is: true,
                      then: Yup.string().required("Commission type is required"),
                      otherwise: Yup.string().nullable(),
                    }),
                    commissionValue: Yup.number().when("isBuyer", {
                      is: true,
                      then: Yup.number()
                        .typeError("Commission value must be a number")
                        .required("Commission value is required"),
                      otherwise: Yup.number().nullable(),
                    }),
                    startDate: Yup.date().nullable().when("buyerType", {
                      is: "1",
                      then: Yup.date().nullable().required("Start Date is required"),
                    }),
                    endDate: Yup.date().nullable().when("buyerType", {
                      is: "1",
                      then: Yup.date().nullable().required("End Date is required"),
                    }),
                    sellerType: Yup.string().when("isSeller", {
                      is: true,
                      then: Yup.string().required("Seller type is required"),
                      otherwise: Yup.string().nullable(),
                    }),
                    sellerCommissionTypeId: Yup.string().when("isSeller", {
                      is: true,
                      then: Yup.string().required("Commission type is required"),
                      otherwise: Yup.string().nullable(),
                    }),
                    sellerCommissionValue: Yup.number().when("isSeller", {
                      is: true,
                      then: Yup.number()
                        .typeError("Commission value must be a number")
                        .required("Commission value is required"),
                      otherwise: Yup.number().nullable(),
                    }),
                    sellerStartDate: Yup.date().nullable().when("sellerType", {
                      is: "2",
                      then: Yup.date().nullable().required("Start Date is required"),
                    }),
                    sellerEndDate: Yup.date().nullable().when("sellerType", {
                      is: "2",
                      then: Yup.date().nullable().required("End Date is required"),
                    }),
                  })}
                  validateOnChange={true}
                  validateOnBlur={true}
                  onSubmit={async (values, { setTouched, setSubmitting }) => {
                    if (values.isBuyer && !values.buyerType) {
                      setTouched({ buyerType: true });
                      return;
                    }

                    if (values.isSeller && !values.sellerType) {
                      setTouched({ sellerType: true });
                      return;
                    }

                    const payload = {
                      ...values,
                      buyerType: values.buyerType ? parseInt(values.buyerType) : 0,
                      sellerType: values.sellerType ? parseInt(values.sellerType) : 0,
                      agentId: parseInt(values.agentId),
                      commissionTypeId: values.commissionTypeId ? parseInt(values.commissionTypeId) : 0,
                      commissionValue: values.commissionValue ? parseFloat(values.commissionValue) : 0,
                      sellerCommissionTypeId: values.sellerCommissionTypeId ? parseInt(values.sellerCommissionTypeId) : 0,
                      sellerCommissionValue: values.sellerCommissionValue ? parseFloat(values.sellerCommissionValue) : 0,
                      lastAgreementDate: (values.lastAgreementDate) ? moment(values.lastAgreementDate).format('YYYY-MM-DD') : null,
                      sellerLastAgreementDate: (values.sellerLastAgreementDate) ? moment(values.lastAgreementDate).format('YYYY-MM-DD') : null,
                      investorLastAgreementDate: (values.investorLastAgreementDate) ? moment(values.investorLastAgreementDate).format('YYYY-MM-DD') : null,
                      startDate: (values.startDate) ? moment(values.startDate).format('YYYY-MM-DD') : null,
                      endDate: (values.endDate) ? moment(values.endDate).format('YYYY-MM-DD') : null,
                      sellerStartDate: (values.sellerStartDate) ? moment(values.sellerStartDate).format('YYYY-MM-DD') : null,
                      sellerEndDate: (values.sellerEndDate) ? moment(values.sellerEndDate).format('YYYY-MM-DD') : null,

                    };
                    const obj = JSON.parse(localStorage.getItem("authUser"));
                    const token = obj?.resultData?.bearerToken;
                    const headers = {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`,
                    };

                    try {
                      toast.loading("Please wait...");
                      const response = await axios.post(`${API_URL}ClientEngagement`, payload, { headers });
                      toast.dismiss();
                      if (response.data.success) {
                        toast.success("Saved successfully");
                        this.props.onGetClientDeals(localStorage.getItem('userId'), this.props.match.params.id)
                        this.toggleAddNew();

                      } else {
                        toast.error(response.data.validationErrors?.[0] || "An error occur#9d3881.");
                      }

                    } catch (error) {
                      toast.dismiss();
                      toast.error(error.response?.data || error.message);

                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({
                    errors,
                    touched,
                    values,
                    handleChange,
                    setFieldValue,
                    setFieldTouched
                  }) => (
                    <Form className="needs-validation">
                      <Row>
                        <Col sm="12">
                          <h4 style={{ paddingTop: 0, paddingBottom: 5 }}>Type of Client</h4>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="12">
                          <div className="d-flex justify-content-between mb-1">
                            <div>
                              <SafeField name="isBuyer" className="form-check-input me-2 offcanvas-chk-box" type="checkbox" id="isBuyer" onClick={e => handleChange(e)} />
                              <label
                                htmlFor="isBuyer"
                                className="form-check-label rs-label-checkbox"
                              >
                                {this.props.t("Buyer")}
                              </label>
                            </div>


                          </div>
                        </Col>
                        <Col sm="12">
                          <div style={{ marginTop: 10 }}>
                            {values.isBuyer && (
                              <>
                                <label className="form-label rs-label-checkbox w-100">
                                  <strong>Select Type *</strong>
                                </label>

                                <div className="form-check form-check-inline rs-radio-check">
                                  <SafeField
                                    type="radio"
                                    name="buyerType"
                                    id="btnradio4"
                                    value="1"
                                    className="form-check-input"
                                  />
                                  <label className="form-check-label" htmlFor="btnradio4">
                                    Looking to Rent
                                  </label>
                                </div>

                                <div className="form-check form-check-inline rs-radio-check">
                                  <SafeField
                                    type="radio"
                                    name="buyerType"
                                    id="btnradio5"
                                    value="2"
                                    className="form-check-input"
                                  />
                                  <label className="form-check-label" htmlFor="btnradio5">
                                    Looking to Purchase
                                  </label>
                                </div>

                                <div style={{ height: 10 }}></div>

                                {/* ErrorMessage handles display automatically */}
                                <ErrorMessage
                                  name="buyerType"
                                  component="div"
                                  className="text-danger"
                                />
                              </>
                            )}
                          </div>
                        </Col>
                      </Row>
                      {values.isBuyer && (
                        <>
                          <Row>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="commissionTypeId">{this.props.t("Commission Type *")}</Label>
                                <SafeField as="select" name="commissionTypeId" id="commissionTypeId"
                                  className={`form-control ${errors.commissionTypeId && touched.commissionTypeId ? "is-invalid" : ""
                                    }`}
                                >
                                  <option value="">Select</option>
                                  <option value="4">Percentage</option>
                                  <option value="3">Fixed</option>

                                </SafeField>
                                <ErrorMessage name="commissionTypeId" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>

                            <Col sm="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="commissionValue">{this.props.t("Commission Value *")}</Label>
                                <SafeField type="text" name="commissionValue"
                                  className={`form-control ${errors.commissionValue && touched.commissionValue ? "is-invalid" : ""
                                    }`}
                                />
                                <ErrorMessage name="commissionValue" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>

                            <Col sm="5">
                              <FormGroup className="mb-3">
                                <Label htmlFor="lastAgreementDate">
                                  {this.props.t("Agreement Date")}
                                </Label>
                                <InputGroup>
                                  <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.lastAgreementDate && touched.lastAgreementDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""
                                    value={values.lastAgreementDate}
                                    onChange={value =>
                                      setFieldValue("lastAgreementDate", value[0])
                                    }
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d",
                                    }}
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text">
                                      <i className="mdi mdi-clock-outline" />
                                    </span>
                                  </div>
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>
                          {values.buyerType == 1 && (
                            <Row>
                              <Col sm="6">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="startDate">
                                    {this.props.t("Tentative start date *")}
                                  </Label>
                                  <InputGroup>
                                    <Flatpickr
                                      className={
                                        "form-control" +
                                        (errors.startDate && touched.startDate ? " is-invalid" : "")
                                      }
                                      placeholder=""
                                      value={values.startDate}
                                      onChange={value => {
                                        setFieldValue("startDate", value[0]);
                                        setFieldTouched("startDate", true);
                                      }}
                                      options={{
                                        altInput: false,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                      }}
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text">
                                        <i className="mdi mdi-clock-outline" />
                                      </span>
                                    </div>
                                    <ErrorMessage name="startDate" component="div" className="invalid-feedback" />
                                  </InputGroup>

                                </FormGroup>
                              </Col>
                              <Col sm="6">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="endDate">
                                    {this.props.t("Tentative End date *")}
                                  </Label>
                                  <InputGroup>
                                    <Flatpickr
                                      className={
                                        "form-control" +
                                        (errors.endDate && touched.endDate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder=""
                                      value=""
                                      onChange={value => {
                                        setFieldValue("endDate", value[0]);
                                        setFieldTouched("endDate", true);
                                      }}

                                      options={{
                                        altInput: false,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                      }}
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text">
                                        <i className="mdi mdi-clock-outline" />
                                      </span>
                                    </div>
                                    <ErrorMessage name="endDate" component="div" className="invalid-feedback" />
                                  </InputGroup>

                                </FormGroup>
                              </Col>
                            </Row>
                          )}
                        </>
                      )}
                      <Row>
                        <Col sm="12">
                          <div className="d-flex justify-content-between mb-1">
                            <div>
                              <SafeField
                                name="isSeller"
                                className="form-check-input me-2 offcanvas-chk-box"
                                type="checkbox"
                                id="isSeller"
                                onClick={e => handleChange(e)}
                              // checked='true'
                              />
                              <label
                                htmlFor="isSeller"
                                className="form-check-label rs-label-checkbox"
                              >
                                {this.props.t("Seller")}
                              </label>
                            </div>

                            {/* </FormGroup> */}
                          </div>
                        </Col>
                        <Col sm="12">
                          <div className="" style={{ marginTop: 10 }}>
                            {values.isSeller && (
                              <>
                                <label className="form-label rs-label-checkbox w-100"><strong>Select Type *</strong></label>

                                <div className="form-check form-check-inline rs-radio-check">
                                  <SafeField
                                    type="radio"
                                    name="sellerType"
                                    id="btnradio6"
                                    value="1"
                                    className="form-check-input"
                                  />
                                  <label className="form-check-label" htmlFor="btnradio6">
                                    Looking to Sell
                                  </label>
                                </div>

                                <div className="form-check form-check-inline rs-radio-check">
                                  <SafeField
                                    type="radio"
                                    name="sellerType"
                                    id="btnradio7"
                                    value="2"
                                    className="form-check-input"
                                  />
                                  <label className="form-check-label" htmlFor="btnradio7">
                                    Looking to Lease
                                  </label>
                                </div>

                                <div style={{ height: 10 }}></div>

                                {/* ErrorMessage handles display automatically */}
                                <ErrorMessage
                                  name="sellerType"
                                  component="div"
                                  className="text-danger"
                                />

                              </>
                            )}

                          </div>
                        </Col>
                      </Row>

                      {values.isSeller && (
                        <>
                          <Row>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="sellerCommissionTypeId">{this.props.t("Commission Type *")}</Label>
                                <SafeField as="select" name="sellerCommissionTypeId"
                                  className={`form-control ${errors.sellerCommissionTypeId && touched.sellerCommissionTypeId ? "is-invalid" : ""
                                    }`}
                                >
                                  <option value="">Select</option>
                                  <option value="4">Percentage</option>
                                  <option value="3">Fixed</option>

                                </SafeField>
                                <ErrorMessage name="sellerCommissionTypeId" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>

                            <Col sm="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="sellerCommissionValue">{this.props.t("Commission Value *")}</Label>
                                <SafeField type="text" name="sellerCommissionValue"
                                  className={`form-control ${errors.sellerCommissionValue && touched.sellerCommissionValue ? "is-invalid" : ""
                                    }`}
                                />
                                <ErrorMessage name="sellerCommissionValue" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>

                            <Col sm="5">
                              <FormGroup className="mb-3">
                                <Label htmlFor="sellerLastAgreementDate">
                                  {this.props.t("Agreement Date")}
                                </Label>
                                <InputGroup>
                                  <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.sellerLastAgreementDate && touched.sellerLastAgreementDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""
                                    value={values.sellerLastAgreementDate}
                                    onChange={value =>
                                      setFieldValue("sellerLastAgreementDate", value[0])
                                    }
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d",
                                    }}
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text">
                                      <i className="mdi mdi-clock-outline" />
                                    </span>
                                  </div>
                                </InputGroup>
                              </FormGroup>
                            </Col>
                          </Row>

                          {values.sellerType == 2 && (
                            <Row>
                              <Col sm="6">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="sellerStartDate">
                                    {this.props.t("Tentative start date *")}
                                  </Label>
                                  <InputGroup>
                                    <Flatpickr
                                      className={
                                        "form-control" +
                                        (errors.sellerStartDate && touched.sellerStartDate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder=""
                                      value=""
                                      onChange={value => {
                                        setFieldValue("sellerStartDate", value[0]);
                                        setFieldTouched("sellerStartDate", true);
                                      }}
                                      options={{
                                        altInput: false,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                      }}
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text">
                                        <i className="mdi mdi-clock-outline" />
                                      </span>
                                    </div>
                                  </InputGroup>
                                  <ErrorMessage name="sellerStartDate" component="div" className="invalid-feedback" />
                                </FormGroup>
                              </Col>
                              <Col sm="6">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="sellerEndDate">
                                    {this.props.t("Tentative End date *")}
                                  </Label>
                                  <InputGroup>
                                    <Flatpickr
                                      className={
                                        "form-control" +
                                        (errors.sellerEndDate && touched.sellerEndDate
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder=""
                                      value=""
                                      onChange={value => {
                                        setFieldValue("sellerEndDate", value[0]);
                                        setFieldTouched("sellerEndDate", true);
                                      }}
                                      options={{
                                        altInput: false,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                      }}
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text">
                                        <i className="mdi mdi-clock-outline" />
                                      </span>
                                    </div>
                                  </InputGroup>
                                  <ErrorMessage name="sellerEndDate" component="div" className="invalid-feedback" />
                                </FormGroup>
                              </Col>
                            </Row>

                          )}
                        </>
                      )}
                      <FormGroup className="mb-3">
                        <SafeField
                          name="isInvestor"
                          className="form-check-input me-2 offcanvas-chk-box"
                          type="checkbox"
                          id="isInvestor"
                          onClick={e => handleChange(e)}
                        // checked='true'
                        />
                        <label
                          htmlFor="isInvestor"
                          className="form-check-label rs-label-checkbox"
                        >
                          {this.props.t("Investor")}
                        </label>
                      </FormGroup>
                      {values.isInvestor && (
                        <Row>


                          <Col sm="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="investorLastAgreementDate">
                                {this.props.t("Agreement Date")}
                              </Label>
                              <InputGroup>
                                <Flatpickr
                                  className={
                                    "form-control" +
                                    (errors.investorLastAgreementDate && touched.investorLastAgreementDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  placeholder=""
                                  value={values.investorLastAgreementDate}
                                  onChange={value =>
                                    setFieldValue("investorLastAgreementDate", value[0])
                                  }
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <i className="mdi mdi-clock-outline" />
                                  </span>
                                </div>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                      )}



                      <div>
                        <SaveButton>Submit</SaveButton>
                      </div>
                    </Form>
                  )}
                </Formik>

              </OffcanvasBody>
            </Offcanvas>

            <Offcanvas
              isOpen={this.state.isManage}
              direction="end"
              toggle={this.toggleManage}
              style={{ width: "1000px" }}
            >
              <OffcanvasHeader toggle={this.toggleManage}>
                Manage Deal
              </OffcanvasHeader>
              <OffcanvasBody>
                <Nav pills className="navtab-bg nav-justified">
                  {/*<NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "1",
                      })}
                      onClick={() => {
                        this.toggle3("1");
                      }}
                    >
                      Deal info
                    </NavLink> 
                  </NavItem>*/}
                  {/* <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "5",
                      })}
                      onClick={() => {
                        this.toggle3("5");
                      }}
                    >
                      Overview
                    </NavLink>
                  </NavItem> */}
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "7",
                      })}
                      onClick={() => {
                        this.toggle3("7");
                      }}
                    >
                      Detail
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "2",
                      })}
                      onClick={() => {
                        this.toggle3("2");
                      }}
                    >
                      Documents
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "3",
                      })}
                      onClick={() => {
                        this.toggle3("3");
                      }}
                    >
                      {deal?.isBuyer ?
                        <>Mortgage / Legal</>
                        : deal?.isSeller ?
                          <>  Lawyer</>
                          :
                          <>Lawyer / Mortgage</>
                      }
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                  <NavLink
                    style={{ 
                      cursor: deal?.isInvestor ? "not-allowed" : "pointer", 
                      pointerEvents: deal?.isInvestor ? "none" : "auto", 
                      opacity: deal?.isInvestor ? 0.1 : 1 
                    }}
                    className={classnames({
                      active: this.state.activeTab3 === "4",
                    })}
                    onClick={() => {
                      if (!deal?.isInvestor) {
                        this.toggle3("6");
                      }
                    }}
                  >
                    Deal Checklist
                  </NavLink>
                </NavItem> */}

                  <NavItem>
                    <NavLink
                      style={{
                        cursor: deal?.isInvestor ? "not-allowed" : "pointer",
                        pointerEvents: deal?.isInvestor ? "none" : "auto",
                        opacity: deal?.isInvestor ? 0.1 : 1
                      }}
                      className={classnames({
                        active: this.state.activeTab3 === "4",
                      })}
                      onClick={() => {
                        if (!deal?.isInvestor) {
                          this.toggle3("4");
                        }
                      }}
                    >
                      Client Checklist
                    </NavLink>
                  </NavItem>

                </Nav>
                <TabContent
                  activeTab={this.state.activeTab3}
                  className="p-3 text-muted"
                >
                  <TabPane tabId="1">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        clientEngagementForId: deal?.clientEngagementId || "",

                        contactName: deal?.contactName || "",
                        contactAddress: deal?.contactAddress || "",
                        clientEngagementStatus: deal?.clientEngagementStatus || "",
                        commissionTypeId: deal?.commissionTypeId || "",
                        commissionValue: deal?.commissionValue || 0,
                        endDate: deal?.endDate || null,
                        startDate: deal?.startDate || null,
                        propertyAddress: deal?.propertyAddress || "",
                        transactionAmount: deal?.transactionAmount,

                      }}
                      validationSchema={Yup.object().shape({
                        contactName: Yup.string().required("Name is required"),
                        startDate: Yup.date().nullable().required("Start date is required"),
                        endDate: Yup.date()
                          .nullable()
                          .min(Yup.ref("startDate"), "End date cannot be before start date"),
                        transactionAmount: Yup.number()
                          .typeError("Transaction amount must be a number")
                          .min(0, "Transaction amount must be greater than 0")
                          .required("Transaction amount is required"),
                        commissionValue: Yup.number()
                          .typeError("Commission value must be a number")
                          .min(0, "Commission value must be greater than 0")
                          .required("Commission value is required"),
                      })}
                      onSubmit={async (values, { setSubmitting }) => {
                        try {
                          toast.loading("Submitting data...");

                          const payload = {
                            ...values,
                            transactionAmount: parseInt(values.transactionAmount),
                            commissionTypeId: parseInt(values.commissionTypeId),
                            commissionValue: parseInt(values.commissionValue),
                            startDate: values.startDate ? values.startDate : null,
                            endDate: values.endDate ? values.endDate : null,
                          };

                          const obj = JSON.parse(localStorage.getItem("authUser"));
                          const token = obj?.resultData?.bearerToken;
                          const headers = {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          };

                          const response = await axios.post(
                            `${API_URL}ClientEngagement/UpdateClientDeal`,
                            payload,
                            { headers }
                          );

                          toast.dismiss();
                          if (response.data.success) {
                            toast.success("Deal Updated Successfully!");
                            this.props.onGetClientDeals(
                              localStorage.getItem("userId"),
                              this.props.match.params.id
                            );
                          } else {
                            toast.error(response.data.validationErrors?.[0] || "An error occur#9d3881.");
                          }
                        } catch (error) {
                          toast.dismiss();
                          toast.error(error.response?.data || error.message);
                        } finally {
                          setSubmitting(false);
                        }
                      }}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form className="needs-validation">
                          <Row>
                            <Col sm="6">
                              <FormGroup className="mb-3">
                                <Label htmlFor="startDate">{this.props.t("Start date")}</Label>
                                <InputGroup>
                                  <Flatpickr
                                    className={`form-control ${errors.startDate && touched.startDate ? "is-invalid" : ""}`}
                                    placeholder=""
                                    value={values.startDate}
                                    onChange={(value) => setFieldValue("startDate", value[0])}
                                    options={{
                                      altInput: true,
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d",
                                    }}
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text">
                                      <i className="mdi mdi-clock-outline" />
                                    </span>
                                  </div>
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            <Col sm="6">  <FormGroup className="mb-3">
                              <Label htmlFor="endDate">{this.props.t("End date")}</Label>
                              <InputGroup>
                                <Flatpickr
                                  className={`form-control ${errors.endDate && touched.endDate ? "is-invalid" : ""}`}
                                  placeholder=""
                                  value={values.endDate}
                                  onChange={(value) => setFieldValue("endDate", value[0])}
                                  options={{
                                    altInput: true,
                                    altFormat: "F j, Y",
                                    dateFormat: "Y-m-d",
                                  }}
                                />
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <i className="mdi mdi-clock-outline" />
                                  </span>
                                </div>
                              </InputGroup>
                            </FormGroup></Col>
                          </Row>




                          <FormGroup className="mb-3">
                            <Label htmlFor="contactName">{this.props.t("Name")}</Label>
                            <SafeField type="text" name="contactName" className="form-control" />
                            <ErrorMessage name="contactName" component="div" className="invalid-feedback" />
                          </FormGroup>

                          <FormGroup className="mb-3">
                            <Label htmlFor="propertyAddress">{this.props.t("Address")}</Label>
                            <PlacesAutocomplete
                              value={values.propertyAddress}
                              onChange={(value) => setFieldValue("propertyAddress", value)}
                            >
                              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                  <input
                                    {...getInputProps({
                                      placeholder: "Enter Address...",
                                      className: "form-control",
                                    })}
                                  />
                                  <div className="">
                                    {loading ? <div>Loading...</div> : null}
                                    {suggestions.map((suggestion, i) => {
                                      const style = suggestion.active
                                        ? { backgroundColor: "#007BFF", color: "#fff", cursor: "pointer", padding: "10px" }
                                        : { backgroundColor: "#fff", cursor: "pointer", padding: "10px" };
                                      return (
                                        <div key={i} {...getSuggestionItemProps(suggestion, { style })}>
                                          {suggestion.description}
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )}
                            </PlacesAutocomplete>
                          </FormGroup>



                          <Row>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="transactionAmount">{this.props.t("Price")}</Label>
                                <SafeField type="text" name="transactionAmount" className="form-control" />
                                <ErrorMessage name="transactionAmount" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="commissionTypeId">{this.props.t("Commission Type")}</Label>
                                <SafeField as="select" name="commissionTypeId" className="form-control">
                                  <option value="">Select</option>
                                  <option value="3">Fixed</option>
                                  <option value="4">%</option>
                                </SafeField>
                                <ErrorMessage name="commissionTypeId" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>

                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="commissionValue">{this.props.t("Commission Value")}</Label>
                                <SafeField type="text" name="commissionValue" className="form-control" />
                                <ErrorMessage name="commissionValue" component="div" className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Col sm="12">
                            <FormGroup className="mb-3">
                              <Label htmlFor="dealNotes">Notes</Label>
                              <SafeField as="textarea" name="dealNotes" className="form-control" />
                              <ErrorMessage name="dealNotes" component="div" className="invalid-feedback" />
                            </FormGroup>
                          </Col>
                          <div>
                            <SaveButton>Submit</SaveButton>{" "}
                            {deal?.clientEngagementStatus === 1 && (
                              <RsAdNew className="btn btn-add" iconClass="" onClick={() => this.deleteDeal(deal)}>Delete Deal</RsAdNew>
                            )}
                          </div>
                        </Form>
                      )}
                    </Formik>

                  </TabPane>
                  <TabPane tabId="5">
                    {deal?.isBuyer ?
                      <>

                        <table className="table  deal-info-table">

                          <tbody>
                            <tr>
                              <th scope="row">Deal Id : <span>{generatedDealId}</span></th>

                              <th scope="row">Deal Type:
                                <span>
                                  {deal?.isBuyer
                                    ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                    : ""}

                                  {deal?.isSeller
                                    ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                                    : ""}
                                </span>
                              </th>
                            </tr>
                            <tr>
                              <th scope="row" colSpan={2}>Address:  <span>{deal?.contactAddress}</span></th>

                            </tr>
                            <tr>
                              <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Agent Info</th>

                            </tr>
                            <tr>
                              <th scope="row">Name: <span>{deal?.agentName}</span></th>

                              <th scope="row">Business Name: <span>{deal?.agentOfficeName}</span></th>

                            </tr>
                            <tr>
                              <th scope="row">Phone: <span>{deal?.agentMobile}</span></th>

                              <th scope="row">Email: <span>{deal?.agentEmail}</span></th>

                            </tr>
                            <tr>
                              <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Client Info</th>
                            </tr>
                            <tr>
                              <th scope="row">Name: <span>{deal?.clientName}</span></th>

                              <th scope="row">Email: <span>{deal?.clientEmail}</span></th>

                            </tr>
                            <tr>
                              <th scope="row">Primary Phone: <span>{deal?.clientMobile}</span></th>

                              <th scope="row">Secondary Phone: <span>{deal?.clientPhone}</span></th>

                            </tr>
                            <tr>
                              <th scope="row" colSpan={4} style={{ color: '#9d3881' }}>Listing Details</th>
                            </tr>
                            <tr>
                              <th scope="row">MLS ID: <span>{buyerListing?.mlsId} {buyerListing?.mlsurl ? <span className="float-end"><a href={buyerListing?.mlsurl} target="_blank" rel="noreferrer"><i className="bx bx-link-external font-size-20"></i></a></span> : ''}</span></th>

                              <th scope="row">Is Interested: <span>{buyerListing?.isInterested ? 'Yes' : 'No'}</span></th>

                            </tr>

                            <tr>
                              <th scope="row">Listing Price: <span>${buyerListing?.listedPrice}</span></th>


                              <th scope="row">Listing Type: <span>{buyerListing?.listingType}</span></th>

                            </tr>
                            <tr>
                              <th scope="row">Bedroom : <span>{buyerListing?.listingBedroom}</span></th>


                              <th scope="row">Bathroom: <span>{buyerListing?.listingBedroom}</span></th>

                            </tr>
                            <tr>
                              <th scope="row">Parking: <span>{buyerListing?.listingParking}</span></th>


                              <th scope="row">Sq. Ft: <span>{buyerListing?.listingSqFt}</span></th>

                            </tr>
                            <tr>
                              <th scope="row">Address: <span>{buyerListing?.listingAddress}</span></th>


                              <th scope="row">City: <span>{buyerListing?.listingCity}</span></th>

                            </tr>


                          </tbody>
                        </table>

                        {deal?.clientEngagementStatus === 1 && (
                          <RsAdNew className="btn btn-add" iconClass="" onClick={() => this.deleteDeal(deal)}>Delete Deal</RsAdNew>
                        )}
                      </>
                      : deal?.isSeller ?
                        <>


                          <table className="table  deal-info-table ">

                            <tbody>
                              <tr>
                                <th scope="row">Deal Id: <span>{generatedDealId}</span></th>

                                <th scope="row">Deal Type:
                                  <span>
                                    {deal?.isBuyer
                                      ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                      : ""}

                                    {deal?.isSeller
                                      ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                                      : ""}
                                  </span>
                                </th>
                              </tr>
                              <tr>
                                <th scope="row" colSpan={2}>Address : <span>{deal?.contactAddress}</span></th>

                              </tr>
                              <tr>
                                <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Agent Info</th>

                              </tr>
                              <tr>
                                <th scope="row">Name : <span>{deal?.agentName}</span></th>

                                <th scope="row">Business Name: <span>{deal?.agentOfficeName}</span></th>

                              </tr>
                              <tr>
                                <th scope="row">Phone: <span>{deal?.agentMobile}</span></th>

                                <th scope="row">Email: <span>{deal?.agentEmail}</span></th>

                              </tr>
                              <tr>
                                <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Client Info</th>
                              </tr>
                              <tr>
                                <th scope="row">Name: <span>{deal?.clientName}</span></th>

                                <th scope="row">Email: <span>{deal?.clientEmail}</span></th>

                              </tr>
                              <tr>
                                <th scope="row">Primary Phone: <span>{deal?.clientMobile}</span></th>

                                <th scope="row">Secondary Phone: <span>{deal?.clientPhone}</span></th>

                              </tr>
                              <tr>
                                <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Listing Detail</th>
                              </tr>
                              <tr>
                                <th scope="row">Listing Id: <span>{sellerListing?.clientListing?.mlsId} {sellerListing?.clientListing?.mlsurl ? <span className="float-end"><a href={sellerListing?.clientListing?.mlsurl} target="_blank" rel="noreferrer"><i className="bx bx-link-external font-size-20"></i></a></span> : ''}</span></th>


                                <th scope="row">Listing Price: <span>{sellerListing?.clientListing?.salePrice ? '$' + sellerListing?.clientListing?.salePrice : ''}</span></th>

                              </tr>
                              <tr>
                                <th scope="row">Showing Date: <span>{sellerListing?.showingDate ? <Moment format="DD MMM YYYY">{sellerListing?.showingDate}</Moment> : ''}</span></th>


                                <th scope="row">Start Time: <span>{sellerListing?.startTime ? <Moment format="hh:ss A">{sellerListing?.startTime}</Moment> : ''}</span></th>



                              </tr>
                              <tr>
                                <th scope="row">End Time: <span>{sellerListing?.endTime ? <Moment format="hh:ss A">{sellerListing?.endTime}</Moment> : ''}</span></th>

                                <th scope="row">Agent Name: <span>{sellerListing?.agentName}</span></th>

                              </tr>
                              <tr>
                                <th scope="row">Agent Organization: <span>{sellerListing?.agentOrganization}</span></th>


                                <th scope="row">Agent Contact : <span>{sellerListing?.agentContact}</span></th>

                              </tr>
                              <tr>
                                <th scope="row">Agent Email: <span>{sellerListing?.agentEmail}</span></th>

                                <th scope="row"></th>

                              </tr>

                            </tbody>
                          </table>

                          {deal?.clientEngagementStatus === 1 && (
                            <RsAdNew className="btn btn-add" iconClass="" onClick={() => this.deleteDeal(deal)}>Delete Deal</RsAdNew>
                          )}

                        </>
                        :
                        <>


                          <table className="table  deal-info-table ">

                            <tbody>
                              <tr>
                                <th scope="row">Deal Id: <span>{generatedDealId}</span></th>

                                <th scope="row">Deal Type: <span>Investor</span></th>



                              </tr>
                              <tr>
                                <th scope="row" colSpan={2}>Address : <span>{deal?.contactAddress}</span></th>

                              </tr>
                              <tr>
                                <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Client Info (Principal applicant)</th>

                              </tr>
                              <tr>
                                <th scope="row">Name:<span>{deal?.clientName}</span></th>

                                <th scope="row">Email: <span>{deal?.clientEmail}</span></th>

                              </tr>
                              <tr>
                                <th scope="row">Primary Phone: <span>{deal?.clientMobile}</span></th>

                                <th scope="row">Secondary Phone: <span>{deal?.clientPhone}</span></th>

                              </tr>
                              <tr>
                                <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Client Info (Secondary)</th>
                              </tr>
                              <tr>
                                <th scope="row">Name: <span>{deal?.secondaryClientName}</span></th>

                                <th scope="row">Email: <span>{deal?.secondaryClientEmail}</span></th>

                              </tr>
                              <tr>
                                <th scope="row">Primary Phone: <span>{deal?.secondaryClientMobile}</span></th>

                                <th scope="row">Secondary Phone: <span>{deal?.secondaryClientPhone}</span></th>

                              </tr>

                              <tr>
                                <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Project Detail</th>
                              </tr>
                              <tr>
                                <th scope="row">Project Name: <span>{investorListing?.project?.projectName}</span></th>


                                <th scope="row">Unit: <span>{investorListing?.projects[0]?.selectedOptionText}</span></th>

                              </tr>
                              <tr>
                                <th scope="row">Builder: <span>{investorListing?.builder?.builderName}</span></th>


                                <th scope="row">Cost: <span>{'$'.investorListing?.projects[0]?.unitCost || ''}</span></th>

                              </tr>

                              <tr>
                                <th scope="row">Inside Sq.ft: <span>{investorListing?.projects[0]?.insideSqFt}</span></th>


                                <th scope="row">Outside Sq.ft: <span>{investorListing?.projects[0]?.outsideSqFt}</span></th>

                              </tr>
                              <tr>
                                <th scope="row" colSpan="2">Notes: <span>{investorListing?.notes}</span></th>
                              </tr>
                            </tbody>
                          </table>
                        </>
                    }

                  </TabPane>

                  <TabPane tabId="2">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{

                        documentStorageType: 0,
                        clientEngagementId: deal?.clientEngagementId,
                        agreementDocumentFromId: localStorage.getItem("userId"),
                        agreementDocumentToId: this.props.match.params.id,
                        agreementDocumentTitle: '',
                        agreementDocumentFrom: 'Realtor',
                        agreementDocumentTo: 'Client',
                        agreementDocumentLink: '',
                        agreementDocumentTypeId: 0,
                        agreementDocumentStorageType: 0,
                        agentId: localStorage.getItem('userId'),
                        isActive: true,
                        isUrgent: false,
                        sendNotification: false
                      }}
                      validationSchema={Yup.object().shape({
                        agreementDocumentLink: Yup.string()
                          .when("documentStorageType", {
                            is: 1,
                            then: Yup.string().required("Document link is required").url("Invalid URL format"),
                            //otherwise: Yup.string().not.required(),
                          }),
                        agreementDocumentTitle: Yup.string().required("This is required")
                      })}
                      onSubmit={this.handleDocumentSubmit}
                    >
                      {({
                        errors,
                        touched,
                        values,
                        handleChange,
                        setFieldValue,
                      }) => (
                        <Form className="needs-validation">
                          {/* <FormGroup className="mb-3"> */}
                          <Row>
                            <Col sm="12">
                              <div className="btn-group" role="group">
                                <SafeField
                                  type="radio"
                                  className="btn-check"
                                  name="documentStorageType"
                                  id="documentStorageType1"
                                  autoComplete="off"
                                  value={0}
                                  onChange={() => setFieldValue("documentStorageType", 0)}
                                />
                                <label
                                  className="btn btn-outline-secondary"
                                  htmlFor="documentStorageType1"
                                >
                                  Upload File
                                </label>

                                <SafeField
                                  type="radio"
                                  className="btn-check"
                                  name="documentStorageType"
                                  id="documentStorageType2"
                                  autoComplete="off"
                                  value={1}
                                  onChange={() => setFieldValue("documentStorageType", 1)}
                                />
                                <label
                                  className="btn btn-outline-secondary"
                                  htmlFor="documentStorageType2"
                                >
                                  Add Link
                                </label>
                              </div>
                            </Col>
                          </Row>

                          {values.documentStorageType === 0 && (

                            <Row>
                              <Col sm="5">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="agreementDocumentTitle">{this.props.t("Title *")}</Label>
                                  <SafeField
                                    name="agreementDocumentTitle"
                                    onChange={handleChange}
                                    type="text"
                                    className={
                                      "form-control" +
                                      (errors.agreementDocumentTitle && touched.agreementDocumentTitle
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="agreementDocumentTitle"
                                  />
                                  <ErrorMessage
                                    name="agreementDocumentTitle"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="5">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="agreementDocumentLink">{this.props.t("Upload Document *")}</Label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    onChange={event => this.handleFileChange(event, setFieldValue)}
                                  />
                                  <small className="text-muted font-size-12">
                                                               {UPLOADTEXT.DFOR}
                                                             </small>
                                </FormGroup>
                              </Col>
                              <Col sm="2">
                                <div style={{ marginTop: 30 }}></div>
                                {fileUploaded ? <SaveButton>Upload</SaveButton> : <button className="btn btn-save" disabled>Upload</button>}

                              </Col>
                            </Row>

                          )}
                          {values.documentStorageType === 1 && (
                            <Row>
                              <Col sm="5">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="agreementDocumentTitle">{this.props.t("Title *")}</Label>
                                  <SafeField
                                    name="agreementDocumentTitle"
                                    onChange={handleChange}
                                    type="text"
                                    className={
                                      "form-control" +
                                      (errors.agreementDocumentTitle && touched.agreementDocumentTitle
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="agreementDocumentTitle"
                                  />
                                  <ErrorMessage
                                    name="agreementDocumentTitle"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="5">
                                <FormGroup className="mb-3">
                                  <Label htmlFor="documentLink">{this.props.t("Link *")}</Label>
                                  <SafeField
                                    name="agreementDocumentLink"
                                    onChange={handleChange}
                                    type="text"
                                    className={
                                      "form-control" +
                                      (errors.agreementDocumentLink && touched.agreementDocumentLink
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="documentLink"
                                  />
                                  <ErrorMessage
                                    name="agreementDocumentLink"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm="2">
                                <div style={{ marginTop: 30 }}></div>
                                <SaveButton>Submit</SaveButton>
                              </Col>
                            </Row>

                          )}





                        </Form>
                      )}
                    </Formik>


                    <table className="align-middle mb-0 table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Title</th>
                          <th>View</th>

                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {dealDocuments?.map((doc, i) => (
                          <tr key={i}>
                            <td>{doc.createdDate ? <Moment format="DD MMM YYYY">{doc.createdDate}</Moment> : ''}</td>
                            <td>{doc.agreementDocumentTitle}</td>
                            <td><a href={doc.agreementDocumentLink} target="_blank" rel="noopener noreferrer">View</a></td>
                            <td><ActionDelete onClick={() => this.handleDeleteDoc(doc)} /></td>
                          </tr>
                        ))}
                      </tbody>

                    </table>
                  </TabPane>
                  <TabPane tabId="3">
                    {/* {(mortgageContact || legalContact) ? (
                      <>
                        {mortgageContact && (
                          <>
                            <h4>Mortgage Contact</h4>
                            <table className="align-middle mb-0 table">
                              <tbody>
                                <tr>
                                  <th scope="row">Name</th>
                                  <td>{`${mortgageContact?.title} ${mortgageContact?.contactFName} ${mortgageContact?.contactLName}`}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Organization Name</th>
                                  <td>{mortgageContact?.organizationName || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Address</th>
                                  <td>{mortgageContact?.clientProfessionalContactAddress?.fullAddress || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Email </th>
                                  <td>{mortgageContact?.primaryContact?.email || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Mobile  </th>
                                  <td>{mortgageContact?.primaryContact?.mobile || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Secondary Phone  </th>
                                  <td>{mortgageContact?.primaryContact?.phone || ''} {mortgageContact?.primaryContact?.phoneExt || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Notes</th>
                                  <td>{mortgageContact?.notes || ''}</td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        )}
                        {legalContact && (
                          <>
                            <h4>Legal Contact</h4>
                            <table className="align-middle mb-0 table">
                              <tbody>
                                <tr>
                                  <th scope="row">Name</th>
                                  <td>{`${legalContact?.title} ${legalContact?.contactFName} ${legalContact?.contactLName}`}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Organization Name</th>
                                  <td>{legalContact?.organizationName || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Address</th>
                                  <td>{legalContact?.clientProfessionalContactAddress?.fullAddress || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Email </th>
                                  <td>{legalContact?.primaryContact?.email || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Mobile  </th>
                                  <td>{legalContact?.primaryContact?.mobile || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Secondary Phone  </th>
                                  <td>{legalContact?.primaryContact?.phone || ''} {legalContact?.primaryContact?.phoneExt || ''}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Notes</th>
                                  <td>{legalContact?.notes || ''}</td>
                                </tr>
                              </tbody>
                            </table>
                          </>
                        )}
                      </>
                    ) : (
                      <p>Not Provided</p>
                    )} */}

                      <h4>Mortgage info</h4>
                     <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                              id:mortgageContact?.id || 0,
                                              clientProfessionalContactId:mortgageContact?.clientProfessionalContactId || '3f9432c8-2c15-46c9-81f7-aff0552eb84a',
                                              dealId: parseInt(deal?.clientEngagementId),
                                              professionalContactTypeId: 2,
                                              title:mortgageContact?.title || '',
                                              notes:mortgageContact?.notes || '',
                                              contactFName: mortgageContact?.contactFName || '',
                                              contactLName: mortgageContact?.contactLName || '',
                                              clientId: parseInt(this.props.match.params.id),
                                              agentId: parseInt(localStorage.getItem('userId')),
                                              primaryContactId:mortgageContact?.primaryContactId || 0,
                                              addressId:mortgageContact?.addressId || 0,
                                              isActive:true,
                                              organizationName: mortgageContact?.organizationName || '',
                                              email: mortgageContact?.primaryContact?.email || '',
                                              phone: mortgageContact?.primaryContact?.phone || '',
                                              mobile: mortgageContact?.primaryContact?.mobile || '',
                                             
                                              fullAddress:mortgageContact?.clientProfessionalContactAddress?.fullAddress || '',
                                              addressLine1:mortgageContact?.clientProfessionalContactAddress?.addressLine1 || '',
                                              addressLine2:mortgageContact?.clientProfessionalContactAddress?.addressLine2 || '',
                                              nearestIntersection:mortgageContact?.clientProfessionalContactAddress?.nearestIntersection || '',
                                              city:mortgageContact?.clientProfessionalContactAddress?.city || '',
                                              province:mortgageContact?.clientProfessionalContactAddress?.province || '',
                                              postal:mortgageContact?.clientProfessionalContactAddress?.postal || '',
                                              country:mortgageContact?.clientProfessionalContactAddress?.country || '',
                                              longitude:mortgageContact?.clientProfessionalContactAddress?.longitude || '',
                                              latitude:mortgageContact?.clientProfessionalContactAddress?.latitude || '', 
                                              
                                             
                                            }}
                                            validationSchema={Yup.object().shape({
                                              title: Yup.string().required("This Field in required"),
                                              contactFName: Yup.string().required("This Field in required"),
                                              contactLName: Yup.string().required("This Field in required"),
                                              organizationName: Yup.string().required('This field is required'),
                                              email: Yup.string().email('Invalid email').required('This Field in required'),
                                              mobile: Yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Enter number is not valid').required('This is required'),
                                              phone: Yup.string().matches(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/, 'Enter number is not valid'),
                                            })}
                    
                                            onSubmit={this.handleSubmitMortgage}
                                          >
                                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                                              <Form
                                                className="needs-validation"
                                              >
                                                <Row>
                                                <Col md="2">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="title">
                                                        {this.props.t("Title *")}
                                                      </Label>
                                                      <Field as="select" name="title" 
                                                       onChange={handleChange}
                                                      className={
                                                        "form-control" +
                                                        (errors.title && touched.title
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      id="title">
                                                          <option value="">Select</option>
                                                          <option value="Mr">Mr</option>
                                                          <option value="Mrs">Mrs</option>
                                                          <option value="Miss">Miss</option>
                                                          <option value="Dr">Dr</option>
                                                          <option value="Prof">Prof</option>

                                                      </Field>
                                                      <ErrorMessage
                                                        name="title"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="5">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="contactFName">
                                                        {this.props.t("First Name *")}
                                                      </Label>
                                                      <Field
                                                        name="contactFName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.contactFName && touched.contactFName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="contactFName"
                                                      />
                                                      <ErrorMessage
                                                        name="contactFName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="5">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="contactLName">
                                                        {this.props.t("Last Name *")}
                                                      </Label>
                                                      <Field
                                                        name="contactLName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.contactLName && touched.contactLName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="contactLName"
                                                      />
                                                      <ErrorMessage
                                                        name="contactLName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                    
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="organizationName">
                                                        {this.props.t("Organization Name *")}
                                                      </Label>
                                                      <Field
                                                        name="organizationName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.organizationName && touched.organizationName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="organizationName"
                                                      />
                                                      <ErrorMessage
                                                        name="organizationName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="8">
                                                            <FormGroup className="mb-3">
                                                              <Label htmlFor="fullAddress">
                                                                {this.props.t("Address")}
                                                              </Label>
                    
                    
                                                              <PlacesAutocomplete
                                                                 value={values.fullAddress}
                                                                 onChange={(value) => setFieldValue('fullAddress', value)}
                                                                onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                                              >
                                                           {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                      <div>
                                                                        <input
                                                                          {...getInputProps({
                                                                            placeholder: 'Enter Address...',
                                                                            className: 'form-control',
                                                                          
                                                                          })}
                                                                        />
                                                                        <div className="">
                                                                          {loading ? <div>Loading...</div> : null}
                    
                                                                          {suggestions.map((suggestion, i) => {
                                                                            const className = suggestion.active
                                                                              ? 'suggestion-item--active'
                                                                              : 'suggestion-item';
                                                                            const style = suggestion.active
                                                                              ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                                              : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                    
                                                                            return (
                                                                              <div
                                                                              key={i}
                                                                                {...getSuggestionItemProps(suggestion, {
                                                                                  style,
                                                                                })}
                                                                              >
                                                                                {suggestion.description}
                                                                              </div>
                                                                            );
                                                                          })}
                                                                        </div>
                                                                      </div>
                                                                    )}
                                                                  </PlacesAutocomplete>
                    
                    
                                                            </FormGroup>
                                                          </Col>
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="email">
                                                        {this.props.t("Email *")}
                                                      </Label>
                                                      <Field
                                                        name="email"
                                                        type="text"
                                                        
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.email && touched.email
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="email"
                                                      />
                                                      <ErrorMessage
                                                        name="email"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                 
                                                  <Col md="3">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="mobile">
                                                        {this.props.t("Mobile *")}
                                                      </Label>
                                                      <Field
                                                        name="mobile"
                                                        type="text"
                                                       
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.mobile && touched.mobile
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="mobile"
                                                      />
                                                      <ErrorMessage
                                                        name="mobile"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="3">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="phone">
                                                        {this.props.t("Secondary Phone")}
                                                      </Label>
                                                      <Field
                                                        name="phone"
                                                        type="text"
                                                       
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.phone && touched.phone
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="phone"
                                                      />
                                                      <ErrorMessage
                                                        name="phone"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="2">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="phoneExt">
                                                        {this.props.t("Ext")}
                                                      </Label>
                                                      <Field
                                                        name="phoneExt"
                                                        type="text"
                                                        //value={values.phone}
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.phoneExt && touched.phoneExt
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="phoneExt"
                                                      />
                                                      <ErrorMessage
                                                        name="phoneExt"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col> 
                                              
                                                 
                                                 
                                               
                                                 
                                                     
                                                
                                                </Row>
                                        
                                                <Row>
                                                  <Col md="12">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="notes">
                                                        {this.props.t("Notes ")}
                                                      </Label>
                                                      <Field
                                                        name="notes"
                                                        onChange={handleChange}
                                                        as="textarea"
                    
                                                        className="form-control"
                    
                                                        id="notes"
                    
                                                      />
                                                    </FormGroup>
                                                  </Col>
                    
                    
                    
                                                </Row>
                    
                    
                    
                    
                    
                    
                                                <div><button type="submit" className="btn btn-primary w-md float-end">Update</button></div>
                    
                                              </Form>
                                            )}
                                          </Formik>

                      <h4>Legal Info</h4>
                         <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                              id:legalContact?.id || 0,
                                              clientProfessionalContactId:legalContact?.clientProfessionalContactId || '3f9432c8-2c15-46c9-81f7-aff0552eb84a',
                                              dealId: parseInt(deal?.clientEngagementId),
                                              professionalContactTypeId: 1,
                                              title:legalContact?.title || '',
                                              notes:legalContact?.notes || '',
                                              contactFName: legalContact?.contactFName || '',
                                              contactLName: legalContact?.contactLName || '',
                                              clientId: parseInt(this.props.match.params.id),
                                              agentId: parseInt(localStorage.getItem('userId')),
                                              primaryContactId:legalContact?.primaryContactId || 0,
                                              addressId:legalContact?.addressId || 0,
                                              isActive:true,
                                              organizationName: legalContact?.organizationName || '',
                                              email: legalContact?.primaryContact?.email || '',
                                              phone: legalContact?.primaryContact?.phone || '',
                                              mobile: legalContact?.primaryContact?.mobile || '',
                                             
                                              fullAddress:legalContact?.clientProfessionalContactAddress?.fullAddress || '',
                                              addressLine1:legalContact?.clientProfessionalContactAddress?.addressLine1 || '',
                                              addressLine2:legalContact?.clientProfessionalContactAddress?.addressLine2 || '',
                                              nearestIntersection:legalContact?.clientProfessionalContactAddress?.nearestIntersection || '',
                                              city:legalContact?.clientProfessionalContactAddress?.city || '',
                                              province:legalContact?.clientProfessionalContactAddress?.province || '',
                                              postal:legalContact?.clientProfessionalContactAddress?.postal || '',
                                              country:legalContact?.clientProfessionalContactAddress?.country || '',
                                              longitude:legalContact?.clientProfessionalContactAddress?.longitude || '',
                                              latitude:legalContact?.clientProfessionalContactAddress?.latitude || '', 
                                              
                                             
                                            }}
                                            validationSchema={Yup.object().shape({
                                              title: Yup.string().required("This Field in required"),
                                              contactFName: Yup.string().required("This Field in required"),
                                              contactLName: Yup.string().required("This Field in required"),
                                              organizationName: Yup.string().required('This field is required'),
                                              email: Yup.string().email('Invalid email').required('This Field in required'),
                                              mobile: Yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Enter number is not valid').required('This is required'),
                                              phone: Yup.string().matches(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/, 'Enter number is not valid'),
                                            })}
                    
                                            onSubmit={this.handleSubmitLowyer}
                                          >
                                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                                              <Form
                                                className="needs-validation"
                                              >
                                               <Row>
                                                <Col md="2">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="title">
                                                        {this.props.t("Title *")}
                                                      </Label>
                                                      <Field as="select" name="title" 
                                                       onChange={handleChange}
                                                      className={
                                                        "form-control" +
                                                        (errors.title && touched.title
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      id="title">
                                                          <option value="">Select</option>
                                                          <option value="Mr">Mr</option>
                                                          <option value="Mrs">Mrs</option>
                                                          <option value="Miss">Miss</option>
                                                          <option value="Dr">Dr</option>
                                                          <option value="Prof">Prof</option>

                                                      </Field>
                                                      <ErrorMessage
                                                        name="title"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="5">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="contactFName">
                                                        {this.props.t("First Name *")}
                                                      </Label>
                                                      <Field
                                                        name="contactFName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.contactFName && touched.contactFName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="contactFName"
                                                      />
                                                      <ErrorMessage
                                                        name="contactFName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="5">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="contactLName">
                                                        {this.props.t("Last Name *")}
                                                      </Label>
                                                      <Field
                                                        name="contactLName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.contactLName && touched.contactLName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="contactLName"
                                                      />
                                                      <ErrorMessage
                                                        name="contactLName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                    
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="organizationName">
                                                        {this.props.t("Organization Name *")}
                                                      </Label>
                                                      <Field
                                                        name="organizationName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.organizationName && touched.organizationName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="organizationName"
                                                      />
                                                      <ErrorMessage
                                                        name="organizationName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="8">
                                                            <FormGroup className="mb-3">
                                                              <Label htmlFor="fullAddress">
                                                                {this.props.t("Address")}
                                                              </Label>
                    
                    
                                                              <PlacesAutocomplete
                                                                 value={values.fullAddress}
                                                                 onChange={(value) => setFieldValue('fullAddress', value)}
                                                                onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                                              >
                                                           {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                      <div>
                                                                        <input
                                                                          {...getInputProps({
                                                                            placeholder: 'Enter Address...',
                                                                            className: 'form-control',
                                                                          
                                                                          })}
                                                                        />
                                                                        <div className="">
                                                                          {loading ? <div>Loading...</div> : null}
                    
                                                                          {suggestions.map((suggestion, i) => {
                                                                            const className = suggestion.active
                                                                              ? 'suggestion-item--active'
                                                                              : 'suggestion-item';
                                                                            const style = suggestion.active
                                                                              ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                                              : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                    
                                                                            return (
                                                                              <div
                                                                              key={i}
                                                                                {...getSuggestionItemProps(suggestion, {
                                                                                  style,
                                                                                })}
                                                                              >
                                                                                {suggestion.description}
                                                                              </div>
                                                                            );
                                                                          })}
                                                                        </div>
                                                                      </div>
                                                                    )}
                                                                  </PlacesAutocomplete>
                    
                    
                                                            </FormGroup>
                                                          </Col>
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="email">
                                                        {this.props.t("Email *")}
                                                      </Label>
                                                      <Field
                                                        name="email"
                                                        type="text"
                                                        
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.email && touched.email
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="email"
                                                      />
                                                      <ErrorMessage
                                                        name="email"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                 
                                                  <Col md="3">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="mobile">
                                                        {this.props.t("Mobile *")}
                                                      </Label>
                                                      <Field
                                                        name="mobile"
                                                        type="text"
                                                       
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.mobile && touched.mobile
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="mobile"
                                                      />
                                                      <ErrorMessage
                                                        name="mobile"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="3">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="phone">
                                                        {this.props.t("Secondary Phone")}
                                                      </Label>
                                                      <Field
                                                        name="phone"
                                                        type="text"
                                                       
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.phone && touched.phone
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="phone"
                                                      />
                                                      <ErrorMessage
                                                        name="phone"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="2">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="phoneExt">
                                                        {this.props.t("Ext")}
                                                      </Label>
                                                      <Field
                                                        name="phoneExt"
                                                        type="text"
                                                        //value={values.phone}
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.phoneExt && touched.phoneExt
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="phoneExt"
                                                      />
                                                      <ErrorMessage
                                                        name="phoneExt"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col> 
                                              
                                                 
                                                 
                                               
                                                 
                                                     
                                                
                                                </Row>
                                        
                                                <Row>
                                                  <Col md="12">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="notes">
                                                        {this.props.t("Notes ")}
                                                      </Label>
                                                      <Field
                                                        name="notes"
                                                        onChange={handleChange}
                                                        as="textarea"
                    
                                                        className="form-control"
                    
                                                        id="notes"
                    
                                                      />
                                                    </FormGroup>
                                                  </Col>
                    
                    
                    
                                                </Row>
                    
                    
                    
                    
                    
                    
                                                <div><button type="submit" className="btn btn-primary w-md float-end">Update</button></div>
                    
                                              </Form>
                                            )}
                                          </Formik>

                  </TabPane>
                  <TabPane tabId="4">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        selectedTasks: this.state.selectedChecklistIds || [],

                      }}
                      validationSchema={Yup.object().shape({})}
                      onSubmit={(values) => {
                        const closingCheckLists = (values.selectedTasks || []).map((taskId) => ({
                          clientClosingCheckListId: parseInt(taskId, 10),
                          clientListingId: 0,
                          clientDealId: parseInt(deal?.clientEngagementId),
                          clientId: parseInt(localStorage.getItem("userId")),
                          agentId: parseInt(localStorage.getItem("agentId")),
                          status: true,
                          isActive: true,
                        }));
                        // toast.loading("Please wait...");
                        const payload = deal?.isBuyer
                          ? { buyerClosingCheckLists: closingCheckLists }
                          : { sellerClosingCheckLists: closingCheckLists };

                        const obj = JSON.parse(localStorage.getItem("authUser"));
                        const token = obj?.resultData?.bearerToken;
                        toast.loading("Please wait...")
                        const url = deal?.isBuyer ? `${API_URL}ClientBuyerClosingCheckList/bulkadd` : `${API_URL}ClientSellerClosingCheckList/bulkadd`;
                        fetch(url, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                          body: JSON.stringify(payload),
                        })
                          .then((response) => {
                            if (!response.ok) {
                              throw new Error(`HTTP error! Status: ${response.status}`);
                            }
                            return response.json();
                          })
                          .then((data) => {
                            
                            toast.dismiss();
                            toast.success("Checklist updated successfully!");
                          })
                          .catch((error) => {
                            console.error("Error:", error);
                            toast.dismiss();
                            toast.error(`Error updating checklist: ${error.message}`);
                          });


                      }}
                    >
                      {({ values, setFieldValue }) => (
                        <Form className="needs-validation">
                          <div className="accordion accordion-flush" id="accordionFlushExample">
                            {groupedChecklist && Object.keys(groupedChecklist).length > 0 ? (
                              <>
                                {Object.entries(groupedChecklist).map(([category, tasks], index) => (
                                  <div className="accordion-item" key={category}>
                                    <h2 className="accordion-header" id={`heading-${index}`}>
                                      <button
                                        className={`accordion-button fw-medium ${this.state.activeCategories[category] ? "" : "collapsed"}`}
                                        type="button"
                                        onClick={() => this.toggleCategory(category)}
                                        style={{ cursor: "pointer" }}
                                      >
                                        {category}
                                      </button>
                                    </h2>

                                    <Collapse isOpen={this.state.activeCategories[category]} className="accordion-collapse">
                                      <div className="accordion-body">
                                        {tasks.length > 0 ? (
                                          <Row>
                                            {tasks.map((task) => (
                                              <Col md="12" key={task.id}>
                                                <FormGroup className="mb-3">
                                                  <input
                                                    name="selectedTasks"
                                                    className="form-check-input me-2"
                                                    type="checkbox"
                                                    id={`task_${task.id}`}
                                                    checked={values.selectedTasks.includes(task.id)}
                                                    onChange={(e) => {
                                                      const checked = e.target.checked;
                                                      setFieldValue(
                                                        "selectedTasks",
                                                        checked
                                                          ? [...values.selectedTasks, task.id]
                                                          : values.selectedTasks.filter((id) => id !== task.id)
                                                      );
                                                    }}
                                                  />
                                                  <Label htmlFor={`task_${task.id}`} className="form-check-label">
                                                    {task.checkListTask}
                                                  </Label>
                                                </FormGroup>
                                              </Col>
                                            ))}
                                          </Row>
                                        ) : (
                                          <p className="text-muted">No tasks available</p>
                                        )}
                                      </div>
                                    </Collapse>
                                  </div>
                                ))}
                              </>
                            ) : null}
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </TabPane>
                  <TabPane tabId="6">

                    {deal?.isBuyer ?
                      <>
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            conditions: newdealChecklists
                              ? newdealChecklists
                                .filter(c => c.status === true)
                                .map(c => c.clientDealCheckListId.toString())
                              : []
                          }}
                          validationSchema={Yup.object().shape({})}
                          onSubmit={(values) => {

                            const payload = {
                              buyerDealCheckLists: this.state.alldealChecklists.map((condition) => {
                                const existingItem = newdealChecklists.find(
                                  (item) => item.clientDealCheckListId === condition.id
                                );

                                return {
                                  id: existingItem ? existingItem.id : 0,
                                  clientDealCheckListStateId: existingItem ? existingItem.clientDealCheckListStateId : "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                                  clientDealCheckListId: condition.id,
                                  clientListingId: 0,
                                  clientDealId: parseInt(deal?.clientEngagementId),
                                  clientId: parseInt(this.props.match.params.id),
                                  agentId: parseInt(localStorage.getItem("userId")) || 0,
                                  status: values.conditions.includes(condition.id.toString()),
                                  isActive: true,
                                };
                              }),
                            };
                            const obj = JSON.parse(localStorage.getItem("authUser"));
                            const token = obj?.resultData?.bearerToken;
                            toast.loading("Please wait...")
                            fetch(`${API_URL}ClientBuyerDealCheckList/bulkadd`, {
                              method: "POST",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                              },
                              body: JSON.stringify(payload),
                            })
                              .then((response) => {
                                if (!response.ok) {
                                  throw new Error(`HTTP error! Status: ${response.status}`);
                                }
                                return response.json();
                              })
                              .then((data) => {
                                
                                toast.dismiss();
                                toast.success("Deal Checklist added successfully!");
                              })
                              .catch((error) => {
                                console.error("Error:", error);
                                toast.dismiss();
                                toast.error(`Error updating checklist: ${error.message}`);
                              });


                          }}

                        >
                          {({ values, setFieldValue }) => (
                            <Form className="needs-validation">
                              <Row>
                                {map(this.state.alldealChecklists, (checklist, index) => (
                                  <Col sm="12" key={index}>

                                    <FormGroup className="mb-3 form-check">
                                      <SafeField
                                        type="checkbox"
                                        name="conditions"
                                        value={checklist.id.toString()}
                                        className="form-check-input"
                                        id={`condition-${index}`}
                                      />
                                      <label className="form-check-label" htmlFor={`condition-${index}`}>
                                        {checklist.checkListTask}
                                      </label>
                                    </FormGroup>
                                  </Col>

                                ))}
                              </Row>

                              <SaveButton>Submit</SaveButton>
                            </Form>
                          )}
                        </Formik>

                      </>
                      : deal?.isSeller ?
                        <>
                          <Formik
                            enableReinitialize={true}
                            initialValues={{
                              conditions: newdealChecklists
                                ? newdealChecklists
                                  .filter(c => c.status === true)
                                  .map(c => c.clientDealCheckListId.toString())
                                : []
                            }}
                            validationSchema={Yup.object().shape({})}
                            onSubmit={(values) => {

                              const payload = {
                                sellerDealCheckLists: this.state.alldealChecklists.map((condition) => {
                                  const existingItem = newdealChecklists.find(
                                    (item) => item.clientDealCheckListId === condition.id
                                  );

                                  return {
                                    id: existingItem ? existingItem.id : 0,
                                    clientDealCheckListStateId: existingItem ? existingItem.clientDealCheckListStateId : "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                                    clientDealCheckListId: condition.id,
                                    clientListingId: 0,
                                    clientDealId: parseInt(deal?.clientEngagementId),
                                    clientId: parseInt(this.props.match.params.id),
                                    agentId: parseInt(localStorage.getItem("userId")) || 0,
                                    status: values.conditions.includes(condition.id.toString()),
                                    isActive: true,
                                  };
                                }),
                              };
                              const obj = JSON.parse(localStorage.getItem("authUser"));
                              const token = obj?.resultData?.bearerToken;
                              toast.loading("Please wait...")
                              fetch(`${API_URL}ClientSellerDealCheckList/bulkadd`, {
                                method: "POST",
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization: `Bearer ${token}`,
                                },
                                body: JSON.stringify(payload),
                              })
                                .then((response) => {
                                  if (!response.ok) {
                                    throw new Error(`HTTP error! Status: ${response.status}`);
                                  }
                                  return response.json();
                                })
                                .then((data) => {
                                  
                                  toast.dismiss();
                                  toast.success("Deal Checklist added successfully!");
                                })
                                .catch((error) => {
                                  console.error("Error:", error);
                                  toast.dismiss();
                                  toast.error(`Error updating checklist: ${error.message}`);
                                });


                            }}

                          >
                            {({ values, setFieldValue }) => (
                              <Form className="needs-validation">
                                <Row>
                                  {map(this.state.alldealChecklists, (checklist, index) => (
                                    <Col sm="12" key={index}>

                                      <FormGroup className="mb-3 form-check">
                                        <SafeField
                                          type="checkbox"
                                          name="conditions"
                                          value={checklist.id.toString()}
                                          className="form-check-input"
                                          id={`condition-${index}`}
                                        />
                                        <label className="form-check-label" htmlFor={`condition-${index}`}>
                                          {checklist.checkListTask}
                                        </label>
                                      </FormGroup>
                                    </Col>

                                  ))}
                                </Row>

                                <SaveButton>Submit</SaveButton>
                              </Form>
                            )}
                          </Formik>
                        </>
                        :
                        <>

                        </>
                    }
                  </TabPane>

                  <TabPane tabId="7">
                    {deal?.isBuyer ?

                      <>
                        {isResponsive ? (
                           <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12 }}>
                          <Row>
                            <Col>
                              <span>
                                <strong>Agreement:</strong> <br/>{deal?.lastAgreementDate ? <Moment format="DD MMM YYYY">{deal?.lastAgreementDate}</Moment> : ''}
                              </span>
                            </Col>

                            <Col>
                              <span><strong>Deal Id:</strong> <br/> {generatedDealId}</span>
                            </Col>

                            <Col>
                              <span>
                                <strong>Type:</strong> <br/> {deal?.isBuyer
                                  ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                  : ""}

                                {deal?.isSeller
                                  ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                                  : ""}
                              </span>
                            </Col>
                          </Row>

                        </Alert>
                        ):(
                           <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12 }}>
                          <Row>
                            <Col>
                              <span>
                                <strong>Agreement:</strong> {deal?.lastAgreementDate ? <Moment format="DD MMM YYYY">{deal?.lastAgreementDate}</Moment> : ''}
                              </span>
                            </Col>

                            <Col>
                              <span><strong>Deal Id:</strong> {generatedDealId}</span>
                            </Col>

                            <Col>
                              <span>
                                <strong>Type:</strong> {deal?.isBuyer
                                  ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                  : ""}

                                {deal?.isSeller
                                  ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                                  : ""}
                              </span>
                            </Col>
                          </Row>

                        </Alert>
                        )}
                       
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            acceptedTerms: false,
                            notes: '',
                            clientEngagementForId: deal?.clientEngagementId,
                            clientEngagementGuId: deal?.clientEngagementGuId,
                            cancellationDate: new Date(),
                            conditions: newdealChecklists
                              ? newdealChecklists
                                .filter(c => c.status === true)
                                .map(c => c.clientDealCheckListId.toString())
                              : []
                          }}
                          validationSchema={Yup.object().shape({
                            acceptedTerms: Yup.boolean().when([], {
                              is: () => this.state.showCard,
                              then: (schema) =>
                                schema
                                  .oneOf([true], "You must accept this before continuing")
                                  .required("Required"),
                              otherwise: (schema) => schema.notRequired(),
                            }),
                            notes: Yup.string().when([], {
                              is: () => this.state.showCard,
                              then: (schema) => schema.trim().required("Please enter notes"),
                              otherwise: (schema) => schema.notRequired(),
                            }),

                          })}
                          onSubmit={(values) => {

                            const payload = {
                              buyerDealCheckLists: this.state.alldealChecklists.map((condition) => {
                                const existingItem = newdealChecklists.find(
                                  (item) => item.clientDealCheckListId === condition.id
                                );

                                return {
                                  id: existingItem ? existingItem.id : 0,
                                  clientDealCheckListStateId: existingItem ? existingItem.clientDealCheckListStateId : "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                                  clientDealCheckListId: condition.id,
                                  clientListingId: 0,
                                  clientDealId: parseInt(deal?.clientEngagementId),
                                  clientId: parseInt(this.props.match.params.id),
                                  agentId: parseInt(localStorage.getItem("userId")) || 0,
                                  status: values.conditions.includes(condition.id.toString()),
                                  isActive: true,
                                };
                              }),
                            };
                            const obj = JSON.parse(localStorage.getItem("authUser"));
                            const token = obj?.resultData?.bearerToken;
                            toast.loading("Please wait...")
                            fetch(`${API_URL}ClientBuyerDealCheckList/bulkadd`, {
                              method: "POST",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                              },
                              body: JSON.stringify(payload),
                            })
                              .then((response) => {
                                if (!response.ok) {
                                  throw new Error(`HTTP error! Status: ${response.status}`);
                                }
                                return response.json();
                              })
                              .then((data) => {
                                
                                toast.dismiss();
                                toast.success("Deal Checklist added successfully!");
                              })
                              .catch((error) => {
                                console.error("Error:", error);
                                toast.dismiss();
                                toast.error(`Error updating checklist: ${error.message}`);
                              });


                          }}

                        >
                          {({ values, errors, touched, handleChange, setFieldValue, setFieldTouched, validateForm, setTouched }) => (
                            <Form className="needs-validation">
                              {clientBuyerOffer?.id > 0 ? (
                                <>
                                  <table className="table  deal-info-table">

                                    <tbody>
                                      <tr>
                                        <th scope="row" colSpan={3} style={{ color: '#000' }}><h5 style={{ fontSize: 16, color: '#000' }}>Deal Checklist
                                          {deal?.clientEngagementStatus === 2 && (
                                            <>
                                              <RsLink className="btn-add ms-4 float-end" iconClass="" onClick={() => this.toggleCard(true)}>Deal fell through</RsLink>
                                              {showCard && (
                                                <Card className="border-full mt-2">
                                                  <CardBody className="fellThrough-txt">
                                                    <p className="">Marking this deal as Fell Through is permanent and cannot be undone.</p>
                                                    <ul>
                                                      <li>All Buyer Listings, Seller Showings, and Open House data linked to this deal will be permanently deleted.</li>
                                                      <li>If the client continues in the future, a new deal will need to be created.</li>
                                                    </ul>
                                                    <div className="form-check mb-3">
                                                      <SafeField
                                                        type="checkbox"
                                                        name="acceptedTerms"
                                                        id="acceptedTerms"
                                                        className="form-check-input"
                                                      />
                                                      <label htmlFor="acceptedTerms" className="form-check-label">
                                                        I understand that this will permanently close this deal for me.
                                                      </label>
                                                      <ErrorMessage
                                                        name="acceptedTerms"
                                                        component="div"
                                                        className="text-danger mt-1"
                                                      />
                                                    </div>
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="notes">
                                                        {this.props.t("Enter notes")}
                                                      </Label>
                                                      <SafeField
                                                        name="notes"
                                                        onChange={handleChange}
                                                        as="textarea"
                                                        style={{ minHeight: 70 }}
                                                        className={
                                                          "form-control" +
                                                          (errors.notes && touched.notes
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="notes"
                                                      />
                                                      <ErrorMessage
                                                        name="notes"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>

                                                    <RsAdNew className="btn-add" iconClass="" onClick={() => this.toggleCard(false)}>Cancel</RsAdNew>{" "}
                                                    <RsAdNew
                                                      className="btn-light"
                                                      iconClass=""
                                                      onClick={async () => {


                                                        setFieldTouched("acceptedTerms", true);
                                                        setFieldTouched("notes", true);


                                                        const errors = await validateForm();

                                                        if (Object.keys(errors).length === 0) {

                                                          this.handleFellThroughSubmit(values);
                                                        } else {

                                                          //
                                                        }
                                                      }}
                                                    >
                                                      Confirm fell through
                                                    </RsAdNew>
                                                  </CardBody>
                                                </Card>
                                              )}
                                            </>

                                          )}


                                          {deal?.clientEngagementStatus === 1 && (
                                            <>
                                              <RsLink className="btn-add ms-4 float-end" iconClass="" onClick={() => this.toggleCard(true)}>Cancel deal</RsLink>
                                              {showCard && (
                                                <Card className="border-full mt-2">
                                                  <CardBody className="fellThrough-txt">
                                                    <p className="">Marking this deal as cancelled is permanent and cannot be undone.</p>
                                                    <ul>
                                                      <li>All Buyer Listings, Seller Showings, and Open House data linked to this deal will be permanently deleted.</li>
                                                      <li>If the client continues in the future, a new deal will need to be created.</li>
                                                    </ul>
                                                    <div className="form-check mb-3">
                                                      <SafeField
                                                        type="checkbox"
                                                        name="acceptedTerms"
                                                        id="acceptedTerms"
                                                        className="form-check-input"
                                                      />
                                                      <label htmlFor="acceptedTerms" className="form-check-label">
                                                        I understand that this will permanently close this deal for me.
                                                      </label>
                                                      <ErrorMessage
                                                        name="acceptedTerms"
                                                        component="div"
                                                        className="text-danger mt-1"
                                                      />
                                                    </div>
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="notes">
                                                        {this.props.t("Enter notes")}
                                                      </Label>
                                                      <SafeField
                                                        name="notes"
                                                        onChange={handleChange}
                                                        as="textarea"
                                                        style={{ minHeight: 70 }}
                                                        className={
                                                          "form-control" +
                                                          (errors.notes && touched.notes
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="notes"
                                                      />
                                                      <ErrorMessage
                                                        name="notes"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>

                                                    <RsAdNew className="btn-light" iconClass="" onClick={() => this.toggleCard(false)}>Close</RsAdNew>{" "}
                                                    <RsAdNew
                                                      className="btn-add"
                                                      iconClass=""
                                                      onClick={async () => {

                                                        setTouched({ acceptedTerms: true, notes: true }, true);
                                                        //setFieldTouched("acceptedTerms", true);
                                                        //setFieldTouched("notes", true);


                                                        const errors = await validateForm();

                                                        if (Object.keys(errors).length === 0) {

                                                          this.handleCancelSubmit(values);
                                                        } else {

                                                          //
                                                        }
                                                      }}
                                                    >
                                                      Confirm cancel
                                                    </RsAdNew>
                                                  </CardBody>
                                                </Card>
                                              )}
                                            </>

                                          )}

                                        </h5></th>
                                      </tr>
                                      <tr>
                                        <td colSpan={3}>
                                          {map(this.state.alldealChecklists, (checklist, index) => (
                                            <div className="form-check form-check-inline" key={index}>
                                              <SafeField
                                                type="checkbox"
                                                name="conditions"
                                                value={checklist.id.toString()}
                                                className="form-check-input"
                                                id={`condition-deal-${index}`}
                                              />
                                              <label
                                                className="form-check-label"
                                                htmlFor={`condition-deal-${index}`}
                                              >
                                                {checklist.checkListTask}
                                              </label>
                                            </div>
                                          ))}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row" colSpan={3}><h6 style={{ color: '#000', fontSize: 16 }}>Offer details</h6></th>

                                      </tr>
                                      <tr>
                                        <th scope="row">
                                          Offer status:
                                          <span>{clientBuyerOffer?.statusTitle}</span></th>
                                        <th scope="row">Deal Id: <span>{generatedDealId}</span></th>

                                        <th scope="row">Id/MLS#:
                                          <span>
                                            {buyerListing?.mlsId}
                                          </span>
                                        </th>
                                      </tr>
                                      <tr>
                                        <th scope="row">Deal Type :

                                          <span>
                                            {deal?.isBuyer
                                              ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                              : ""}

                                            {deal?.isSeller
                                              ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                                              : ""}
                                          </span>
                                        </th>

                                        <th scope="row">
                                          {deal?.buyerType === 1 && deal?.startDate && (
                                            <>
                                              Start Date :{" "}
                                              <span>
                                                <Moment format="DD MMM YYYY">{deal.startDate}</Moment>
                                              </span>
                                            </>
                                          )}

                                        </th>

                                        <th scope="row">
                                          {deal?.buyerType === 1 && deal?.endDate && (
                                            <>
                                              End Date :{" "}
                                              <span>
                                                <Moment format="DD MMM YYYY">{deal.endDate}</Moment>
                                              </span>
                                            </>
                                          )}

                                        </th>

                                      </tr>
                                      <tr>
                                        <th scope="row" colSpan={3}>Property address : {clientBuyerOffer?.propertyAddress}</th>

                                      </tr>
                                      <tr>
                                        <th scope="row" colSpan={3}><h6><strong>Conditions checklist</strong></h6></th>

                                      </tr>
                                      <tr>
                                        <th scope="row" colSpan={3}>
                                          <div>
                                            {clientBuyerOffer?.clientDealConditionStates?.map((condition, index) => (
                                              <div className="form-check form-check-inline" key={index}>
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`condition-${index}`}
                                                  value=""
                                                  checked={condition.status}
                                                />
                                                <label className="form-check-label" htmlFor={`condition-${index}`}>
                                                  {condition.clientDealConditionTitle || `Condition ${condition.clientDealConditionId}`}
                                                </label>
                                              </div>
                                            ))}
                                          </div>

                                        </th>

                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          Receive date:
                                          <span>{clientBuyerOffer?.offerDate ? <Moment format="DD MMM YYYY">{clientBuyerOffer?.offerDate}</Moment> : ''}</span></th>
                                        <th scope="row">Offer Price: <span>
                                          <CurrencyFormat
                                            value={clientBuyerOffer?.offerPrice || 0}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={deal?.currencyCode ? deal?.currencyCode + " " : "$"}
                                            decimalScale={2}
                                            fixedDecimalScale={true}
                                          />


                                        </span></th>

                                        <th scope="row">Deposit amount:
                                          <span>
                                            <CurrencyFormat
                                              value={clientBuyerOffer?.deposit || 0}
                                              displayType={'text'}
                                              thousandSeparator={true}
                                              prefix={deal?.currencyCode ? deal?.currencyCode + " " : "$"}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                            />

                                          </span>
                                        </th>
                                      </tr>

                                      <tr>
                                        <th scope="row">
                                          Closing date:
                                          <span>{clientBuyerOffer?.closingDate ? <Moment format="DD MMM YYYY">{clientBuyerOffer?.closingDate}</Moment> : ''}</span></th>
                                        <th scope="row" colSpan={2}> Offer expiry date/time:  <span>{clientBuyerOffer?.expiryDate ? <Moment format="DD MMM YYYY">{clientBuyerOffer?.expiryDate}</Moment> : ''} {clientBuyerOffer?.expiryTime}</span></th>


                                      </tr>
                                      {clientBuyerOffer?.notes && (
                                        <>
                                          <tr>
                                            <th scope="row" colSpan={3}>
                                              <h6 style={{ fontWeight: 'bold' }}>
                                                Special requests/clauses/conditions/notes
                                              </h6>
                                            </th>
                                          </tr>
                                          <tr>
                                            <th scope="row" colSpan={3}>
                                              <span>{clientBuyerOffer.notes}</span>
                                            </th>
                                          </tr>
                                        </>
                                      )}
                                      <tr>
                                        <th scope="row" colSpan={3} style={{ color: '#000' }}><h6 style={{ fontSize: 16 }}>Listing Agent</h6></th>

                                      </tr>
                                      <tr>
                                        <th scope="row">Name : <span>{clientBuyerOffer?.agentName}</span></th>

                                        <th scope="row">Business Name: <span>{clientBuyerOffer?.agentOfficeName}</span></th>
                                        <th scope="row"></th>

                                      </tr>
                                      <tr>
                                        <th scope="row">Phone: <span>{clientBuyerOffer?.agentMobile}</span></th>

                                        <th scope="row">Email: <span>{clientBuyerOffer?.agentEmail}</span></th>
                                        <th scope="row"></th>

                                      </tr>

                                      <tr>
                                        <th scope="row" colSpan={4} style={{ color: '#000' }}><h6 style={{ fontSize: 16 }}>Listing Details</h6></th>
                                      </tr>
                                      <tr>
                                        <th scope="row">MLS ID: <span>{buyerListing?.mlsId} {buyerListing?.mlsurl ? <span className="float-end"><a href={buyerListing?.mlsurl} target="_blank" rel="noreferrer"><i className="bx bx-link-external font-size-20"></i></a></span> : ''}</span></th>

                                        <th scope="row">Listing Price: <span>${buyerListing?.listedPrice}</span></th>

                                        <th scope="row">Bedroom : <span>{buyerListing?.listingBedroom}</span></th>

                                      </tr>


                                      <tr>



                                        <th scope="row">Bathroom: <span>{buyerListing?.listingBedroom}</span></th>
                                        <th scope="row">Parking: <span>{buyerListing?.listingParking}</span></th>
                                        <th scope="row">Sq. Ft: <span>{buyerListing?.listingSqFt}</span></th>

                                      </tr>

                                      {/* <tr>
                        
                     
                     
                        <th scope="row">City: <span>{buyerListing?.listingCity}</span></th>
                     
                      </tr> */}
                                    </tbody>

                                  </table>
                                  {deal?.clientEngagementStatus === 2 && (
                                    <SaveButton>Submit</SaveButton>
                                  )}

                                  <RsLink onClick={this.toggleManage}>Close</RsLink>
                                </>
                              ) : (
                                <Alert color="danger">Deal status: {this.getStatus(deal?.clientEngagementStatus)}</Alert>
                              )}
                            </Form>
                          )}

                        </Formik>

                      </>
                      : deal?.isSeller ?
                        <>
                          {isResponsive ? (
                             <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12 }}>
                            <Row>
                              <Col>
                                <span>
                                  <strong>Agreement:</strong><br /> {deal?.lastAgreementDate ? <Moment format="DD MMM YYYY">{deal?.lastAgreementDate}</Moment> : ''}
                                </span>
                              </Col>

                              <Col>
                                <span> <strong>Deal Id:</strong> <br /> {generatedDealId}</span>
                              </Col>

                              <Col>
                                <span>
                                  <strong>Type:</strong> <br /> {deal?.isBuyer
                                    ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                    : ""}

                                  {deal?.isSeller
                                    ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                                    : ""}
                                </span>
                              </Col>
                            </Row>

                          </Alert>
                          ):(
                             <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12 }}>
                            <Row>
                              <Col>
                                <span>
                                  <strong>Agreement:</strong> {deal?.lastAgreementDate ? <Moment format="DD MMM YYYY">{deal?.lastAgreementDate}</Moment> : ''}
                                </span>
                              </Col>

                              <Col>
                                <span> <strong>Deal Id:</strong> {generatedDealId}</span>
                              </Col>

                              <Col>
                                <span>
                                  <strong>Type:</strong> {deal?.isBuyer
                                    ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                    : ""}

                                  {deal?.isSeller
                                    ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                                    : ""}
                                </span>
                              </Col>
                            </Row>

                          </Alert>
                          )}
                         
                          <Formik
                            enableReinitialize={true}
                            initialValues={{
                              acceptedTerms: false,
                              notes: '',
                              clientEngagementForId: deal?.clientEngagementId,
                              clientEngagementGuId: deal?.clientEngagementGuId,
                              cancellationDate: new Date(),
                              conditions: newdealChecklists
                                ? newdealChecklists
                                  .filter(c => c.status === true)
                                  .map(c => c.clientDealCheckListId.toString())
                                : []
                            }}
                            validationSchema={Yup.object().shape({})}
                            onSubmit={(values) => {

                              const payload = {
                                sellerDealCheckLists: this.state.alldealChecklists.map((condition) => {
                                  const existingItem = newdealChecklists.find(
                                    (item) => item.clientDealCheckListId === condition.id
                                  );

                                  return {
                                    id: existingItem ? existingItem.id : 0,
                                    clientDealCheckListStateId: existingItem ? existingItem.clientDealCheckListStateId : "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                                    clientDealCheckListId: condition.id,
                                    clientListingId: 0,
                                    clientDealId: parseInt(deal?.clientEngagementId),
                                    clientId: parseInt(this.props.match.params.id),
                                    agentId: parseInt(localStorage.getItem("userId")) || 0,
                                    status: values.conditions.includes(condition.id.toString()),
                                    isActive: true,
                                  };
                                }),
                              };
                              const obj = JSON.parse(localStorage.getItem("authUser"));
                              const token = obj?.resultData?.bearerToken;
                              toast.loading("Please wait...")
                              fetch(`${API_URL}ClientSellerDealCheckList/bulkadd`, {
                                method: "POST",
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization: `Bearer ${token}`,
                                },
                                body: JSON.stringify(payload),
                              })
                                .then((response) => {
                                  if (!response.ok) {
                                    throw new Error(`HTTP error! Status: ${response.status}`);
                                  }
                                  return response.json();
                                })
                                .then((data) => {
                                  
                                  toast.dismiss();
                                  toast.success("Deal Checklist added successfully!");
                                })
                                .catch((error) => {
                                  console.error("Error:", error);
                                  toast.dismiss();
                                  toast.error(`Error updating checklist: ${error.message}`);
                                });


                            }}

                          >
                            {({ values, errors, touched, handleChange, setFieldValue, setFieldTouched, validateForm, setTouched }) => (
                              <Form className="needs-validation">
                                {clientSellerOffer?.id > 0 ? (
                                  <>
                                    <table className="table  deal-info-table">

                                      <tbody>
                                        <tr>
                                          <th scope="row" colSpan={3} style={{ color: '#000' }}><h5 style={{ fontSize: 16, color: '#000' }}>Deal Checklist
                                            {deal?.clientEngagementStatus === 2 && (
                                              <>
                                                <RsLink className="btn-add ms-4 float-end" iconClass="" onClick={() => this.toggleCard(true)}>Deal fell through</RsLink>
                                                {showCard && (
                                                  <Card className="border-full mt-2">
                                                    <CardBody className="fellThrough-txt">
                                                      <p className="">Marking this deal as Fell Through is permanent and cannot be undone.</p>
                                                      <ul>
                                                        <li>All Buyer Listings, Seller Showings, and Open House data linked to this deal will be permanently deleted.</li>
                                                        <li>If the client continues in the future, a new deal will need to be created.</li>
                                                      </ul>
                                                      <div className="form-check mb-3">
                                                        <SafeField
                                                          type="checkbox"
                                                          name="acceptedTerms"
                                                          id="acceptedTerms"
                                                          className="form-check-input"
                                                        />
                                                        <label htmlFor="acceptedTerms" className="form-check-label">
                                                          I understand that this will permanently close this deal for me.
                                                        </label>
                                                        <ErrorMessage
                                                          name="acceptedTerms"
                                                          component="div"
                                                          className="text-danger mt-1"
                                                        />
                                                      </div>
                                                      <FormGroup className="mb-3">
                                                        <Label htmlFor="notes">
                                                          {this.props.t("Enter notes")}
                                                        </Label>
                                                        <SafeField
                                                          name="notes"
                                                          onChange={handleChange}
                                                          as="textarea"
                                                          style={{ minHeight: 70 }}
                                                          className={
                                                            "form-control" +
                                                            (errors.notes && touched.notes
                                                              ? " is-invalid"
                                                              : "")
                                                          }
                                                          id="notes"
                                                        />
                                                        <ErrorMessage
                                                          name="notes"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </FormGroup>

                                                      <RsAdNew className="btn-add" iconClass="" onClick={() => this.toggleCard(false)}>Cancel</RsAdNew>{" "}
                                                      <RsAdNew
                                                        className="btn-light"
                                                        iconClass=""
                                                        onClick={async () => {


                                                          setFieldTouched("acceptedTerms", true);
                                                          setFieldTouched("notes", true);


                                                          const errors = await validateForm();

                                                          if (Object.keys(errors).length === 0) {

                                                            this.handleFellThroughSubmit(values);
                                                          } else {

                                                            //
                                                          }
                                                        }}
                                                      >
                                                        Confirm fell through
                                                      </RsAdNew>
                                                    </CardBody>
                                                  </Card>
                                                )}
                                              </>

                                            )}


                                            {deal?.clientEngagementStatus === 1 && (
                                              <>
                                                <RsLink className="btn-add ms-4 float-end" iconClass="" onClick={() => this.toggleCard(true)}>Cancel deal</RsLink>
                                                {showCard && (
                                                  <Card className="border-full mt-2">
                                                    <CardBody className="fellThrough-txt">
                                                      <p className=""><strong>Please note</strong>, cancelling a deal is permanent and cannot be a done</p>
                                                      <ul>
                                                        <li>All Buyer Listings, Seller Showings, and Open House data linked to this deal will be permanently deleted.</li>
                                                        <li>If the client continues in the future, a new deal will need to be created.</li>
                                                      </ul>
                                                      <div className="form-check mb-3">
                                                        <SafeField
                                                          type="checkbox"
                                                          name="acceptedTerms"
                                                          id="acceptedTerms"
                                                          className="form-check-input"
                                                        />
                                                        <label htmlFor="acceptedTerms" className="form-check-label">
                                                          I understand that this will permanently close this deal for me.
                                                        </label>
                                                        <ErrorMessage
                                                          name="acceptedTerms"
                                                          component="div"
                                                          className="text-danger mt-1"
                                                        />
                                                      </div>
                                                      <FormGroup className="mb-3">
                                                        <Label htmlFor="notes">
                                                          {this.props.t("Enter notes")}
                                                        </Label>
                                                        <SafeField
                                                          name="notes"
                                                          onChange={handleChange}
                                                          as="textarea"
                                                          style={{ minHeight: 70 }}
                                                          className={
                                                            "form-control" +
                                                            (errors.notes && touched.notes
                                                              ? " is-invalid"
                                                              : "")
                                                          }
                                                          id="notes"
                                                        />
                                                        <ErrorMessage
                                                          name="notes"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </FormGroup>

                                                      <RsAdNew className="btn-light" iconClass="" onClick={() => this.toggleCard(false)}>Close</RsAdNew>{" "}
                                                      <RsAdNew
                                                        className="btn-add"
                                                        iconClass=""
                                                        onClick={async () => {

                                                          setTouched({ acceptedTerms: true, notes: true }, true);
                                                          //setFieldTouched("acceptedTerms", true);
                                                          //setFieldTouched("notes", true);


                                                          const errors = await validateForm();

                                                          if (Object.keys(errors).length === 0) {

                                                            this.handleCancelSubmit(values);
                                                          } else {

                                                            //
                                                          }
                                                        }}
                                                      >
                                                        Confirm cancel
                                                      </RsAdNew>
                                                    </CardBody>
                                                  </Card>
                                                )}
                                              </>

                                            )}

                                            {deal?.clientEngagementStatus === 0 && (
                                              <>
                                                <RsLink className="btn-add ms-4 float-end" iconClass="" onClick={() => this.toggleCard(true)}>Cancel deal</RsLink>
                                                {showCard && (
                                                  <Card className="border-full mt-2">
                                                    <CardBody className="fellThrough-txt">
                                                      <p className=""><strong>Please note</strong>, cancelling a deal is permanent and cannot be a done</p>
                                                      <ul>
                                                        <li>All Buyer Listings, Seller Showings, and Open House data linked to this deal will be permanently deleted.</li>
                                                        <li>If the client continues in the future, a new deal will need to be created.</li>
                                                      </ul>
                                                      <div className="form-check mb-3">
                                                        <SafeField
                                                          type="checkbox"
                                                          name="acceptedTerms"
                                                          id="acceptedTerms"
                                                          className="form-check-input"
                                                        />
                                                        <label htmlFor="acceptedTerms" className="form-check-label">
                                                          I understand that this will permanently close this deal for me.
                                                        </label>
                                                        <ErrorMessage
                                                          name="acceptedTerms"
                                                          component="div"
                                                          className="text-danger mt-1"
                                                        />
                                                      </div>
                                                      <FormGroup className="mb-3">
                                                        <Label htmlFor="notes">
                                                          {this.props.t("Enter notes")}
                                                        </Label>
                                                        <SafeField
                                                          name="notes"
                                                          onChange={handleChange}
                                                          as="textarea"
                                                          style={{ minHeight: 70 }}
                                                          className={
                                                            "form-control" +
                                                            (errors.notes && touched.notes
                                                              ? " is-invalid"
                                                              : "")
                                                          }
                                                          id="notes"
                                                        />
                                                        <ErrorMessage
                                                          name="notes"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </FormGroup>

                                                      <RsAdNew className="btn-light" iconClass="" onClick={() => this.toggleCard(false)}>Close</RsAdNew>{" "}
                                                      <RsAdNew
                                                        className="btn-add"
                                                        iconClass=""
                                                        onClick={async () => {

                                                          setTouched({ acceptedTerms: true, notes: true }, true);
                                                          //setFieldTouched("acceptedTerms", true);
                                                          //setFieldTouched("notes", true);


                                                          const errors = await validateForm();

                                                          if (Object.keys(errors).length === 0) {

                                                            this.handleCancelSubmit(values);
                                                          } else {

                                                            //
                                                          }
                                                        }}
                                                      >
                                                        Confirm cancel
                                                      </RsAdNew>
                                                    </CardBody>
                                                  </Card>
                                                )}
                                              </>

                                            )}

                                          </h5></th>
                                        </tr>
                                        <tr>
                                          <td colSpan={3}>
                                            {map(this.state.alldealChecklists, (checklist, index) => (
                                              <div className="form-check form-check-inline" key={index}>
                                                <SafeField
                                                  type="checkbox"
                                                  name="conditions"
                                                  value={checklist.id.toString()}
                                                  className="form-check-input"
                                                  id={`condition-deal-${index}`}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor={`condition-deal-${index}`}
                                                >
                                                  {checklist.checkListTask}
                                                </label>
                                              </div>
                                            ))}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th scope="row" colSpan={3} style={{ color: '#000' }}><h5 style={{ fontSize: 16, color: '#000' }}>Offer  Detail</h5></th>
                                        </tr>
                                        <tr>
                                          <th scope="row">
                                            Offer status:
                                            <span>{clientSellerOffer?.statusTitle}</span></th>
                                          <th scope="row">Deal Id: <span>{generatedDealId}</span></th>

                                          <th scope="row">Id/MLS#:
                                            <span>
                                              {sellerListing?.clientListing?.mlsId}
                                            </span>
                                          </th>
                                        </tr>
                                        <tr>
                                          <th scope="row">Deal Type :

                                            <span>
                                              {deal?.isBuyer
                                                ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                                : ""}

                                              {deal?.isSeller
                                                ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                                                : ""}
                                            </span>
                                          </th>

                                          <th scope="row">
                                            {deal?.sellerType === 2 && deal?.sellerStartDate && (
                                              <>
                                                Start Date :{" "}
                                                <span>
                                                  <Moment format="DD MMM YYYY">{deal.sellerStartDate}</Moment>
                                                </span>
                                              </>
                                            )}

                                          </th>

                                          <th scope="row">
                                            {deal?.sellerType === 2 && deal?.sellerEndDate && (
                                              <>
                                                End Date :{" "}
                                                <span>
                                                  <Moment format="DD MMM YYYY">{deal.sellerEndDate}</Moment>
                                                </span>
                                              </>
                                            )}

                                          </th>

                                        </tr>

                                        <tr>
                                          <th scope="row">
                                            Receive date:
                                            <span>{clientSellerOffer?.offerDate ? <Moment format="DD MMM YYYY">{clientSellerOffer?.offerDate}</Moment> : ''}</span></th>
                                          <th scope="row">Offer Price: <span>
                                            <CurrencyFormat
                                              value={clientSellerOffer?.offerPrice || 0}
                                              displayType={'text'}
                                              thousandSeparator={true}
                                              prefix={deal?.currencyCode ? deal?.currencyCode + " " : "$"}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                            />


                                          </span></th>

                                          <th scope="row">Deposit amount:
                                            <span>
                                              <CurrencyFormat
                                                value={clientSellerOffer?.deposit || 0}
                                                displayType={'text'}
                                                thousandSeparator={true}
                                                prefix={deal?.currencyCode ? deal?.currencyCode + " " : "$"}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                              />

                                            </span>
                                          </th>
                                        </tr>

                                        <tr>
                                          <th scope="row">
                                            Closing date:
                                            <span>{clientSellerOffer?.closingDate ? <Moment format="DD MMM YYYY">{clientSellerOffer?.closingDate}</Moment> : ''}</span></th>
                                          <th scope="row" colSpan={2}>Offer expiry date/time:

                                            <span>
                                              {clientSellerOffer?.expiryDate ? (
                                                <>
                                                  <Moment format="DD MMM YYYY">{clientSellerOffer.expiryDate}</Moment> {clientSellerOffer.expiryTime}
                                                </>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                          </th>


                                        </tr>
                                        <tr>
                                          <th scope="row" colSpan={3}><h6 style={{ color: '#000', fontSize: 16 }}>Condition/clauses</h6></th>

                                        </tr>
                                        <tr>
                                          <th scope="row" colSpan={3}>
                                            <div>
                                              {clientSellerOffer?.clientDealConditionStates?.map((condition, index) => (
                                                <div className="form-check form-check-inline" key={index}>
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`condition-${index}`}
                                                    value=""
                                                    checked={condition.status}
                                                  />
                                                  <label className="form-check-label" htmlFor={`condition-${index}`}>
                                                    {condition.clientDealConditionTitle || `Condition ${condition.clientDealConditionId}`}
                                                  </label>
                                                </div>
                                              ))}
                                            </div>

                                          </th>

                                        </tr>
                                        {clientSellerOffer?.notes && (
                                          <>
                                            <tr>
                                              <th scope="row" colSpan={3}><h6 style={{ color: '#000', fontWeight: 'bold' }}>Special requests/clauses/conditions/notes</h6></th>

                                            </tr>
                                            <tr>
                                              <th scope="row" colSpan={3}><span>{clientSellerOffer?.notes}</span></th>

                                            </tr>
                                          </>
                                        )}
                                        <tr>
                                          <th scope="row">Buyer Name : <span>{clientSellerOffer?.partyName}</span></th>

                                          <th scope="row"></th>
                                          <th scope="row"></th>

                                        </tr>
                                        <tr>
                                          <th scope="row" colSpan={3}><h6 style={{ color: '#000', fontSize: 16 }}>Agent Info</h6></th>

                                        </tr>
                                        <tr>
                                          <th scope="row">Name : <span>{clientSellerOffer?.agentName}</span></th>

                                          <th scope="row">Business Name: <span>{clientSellerOffer?.agentOfficeName}</span></th>
                                          <th scope="row"></th>

                                        </tr>
                                        <tr>
                                          <th scope="row">Phone: <span>{clientSellerOffer?.agentMobile}</span></th>

                                          <th scope="row">Email: <span>{clientSellerOffer?.agentEmail}</span></th>
                                          <th scope="row"></th>

                                        </tr>


                                      </tbody>
                                    </table>

                                    {deal?.clientEngagementStatus === 2 && (
                                      <SaveButton>Submit</SaveButton>
                                    )}
                                    <RsLink onClick={this.toggleManage}>Close</RsLink>
                                  </>
                                ) : (
                                  <Alert color="danger">Deal status: {this.getStatus(deal?.clientEngagementStatus)}</Alert>
                                )}
                              </Form>
                            )}
                          </Formik>

                        </>
                        :
                        <>


                          <>


                            <table className="table  deal-info-table ">

                              <tbody>
                                <tr>
                                  <th scope="row">Deal Id: <span>{generatedDealId}</span></th>

                                  <th scope="row">Deal Type: <span>Investor</span></th>



                                </tr>
                                <tr>
                                  <th scope="row" colSpan={2}>Address : <span>{deal?.contactAddress}</span></th>

                                </tr>
                                <tr>
                                  <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Client Info (Principal applicant)</th>

                                </tr>
                                <tr>
                                  <th scope="row">Name:<span>{deal?.clientName}</span></th>

                                  <th scope="row">Email: <span>{deal?.clientEmail}</span></th>

                                </tr>
                                <tr>
                                  <th scope="row">Primary Phone: <span>{deal?.clientMobile}</span></th>

                                  <th scope="row">Secondary Phone: <span>{deal?.clientPhone}</span></th>

                                </tr>
                                <tr>
                                  <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Client Info (Secondary)</th>
                                </tr>
                                <tr>
                                  <th scope="row">Name: <span>{deal?.secondaryClientName}</span></th>

                                  <th scope="row">Email: <span>{deal?.secondaryClientEmail}</span></th>

                                </tr>
                                <tr>
                                  <th scope="row">Primary Phone: <span>{deal?.secondaryClientMobile}</span></th>

                                  <th scope="row">Secondary Phone: <span>{deal?.secondaryClientPhone}</span></th>

                                </tr>

                                <tr>
                                  <th scope="row" colSpan={2} style={{ color: '#9d3881' }}>Project Detail</th>
                                </tr>
                                <tr>
                                  <th scope="row">Project Name: <span>{investorListing?.project?.projectName}</span></th>


                                  <th scope="row">Unit: <span>{investorListing?.projects[0]?.selectedOptionText}</span></th>

                                </tr>
                                <tr>
                                  <th scope="row">Builder: <span>{investorListing?.builder?.builderName}</span></th>


                                  <th scope="row">Cost: <span>${investorListing?.projects[0]?.unitCost}</span></th>

                                </tr>

                                <tr>
                                  <th scope="row">Inside Sq.ft: <span>{investorListing?.projects[0]?.insideSqFt}</span></th>


                                  <th scope="row">Outside Sq.ft: <span>{investorListing?.projects[0]?.outsideSqFt}</span></th>

                                </tr>
                                {/* <tr>
                                  <th scope="row" colSpan="2">Notes: <span>{investorListing?.notes}</span></th>
                                </tr> */}
                              </tbody>
                            </table>
                          </>
                        </>
                    }

                  </TabPane>
                </TabContent>
              </OffcanvasBody>
            </Offcanvas>


            <Offcanvas
              isOpen={this.state.isManage2}
              direction="end"
              toggle={this.toggleManage2}
              style={{ width: "900px" }}
            >
              <OffcanvasHeader toggle={this.toggleManage2}>
                Manage Deal
              </OffcanvasHeader>
              <OffcanvasBody>
                <table className="table  deal-info-table">
                  <tbody>
                    <tr>
                      <th scope="row"><strong>Date</strong> <span>{deal?.cancellationFellThroughDate ? <Moment format="DD MMM YYYY">{deal?.cancellationFellThroughDate}</Moment> : ''}</span></th>
                    </tr>
                    <tr>
                      <th scope="row"><strong>Notes</strong> <span>{deal?.cancellationFellThroughNotes}</span></th>
                    </tr>
                  </tbody>
                </table>

              </OffcanvasBody>
            </Offcanvas>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientDeals.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  onGetClientDetail: PropTypes.func,
  clietDetail: PropTypes.object,
  loading: PropTypes.object,
  onGetClientDeals: PropTypes.func,
  deals: PropTypes.array,
  onDeleteDeal: PropTypes.func,
  onGetListingType: PropTypes.func,
  listingtypes: PropTypes.array,
  onGetUserDetail: PropTypes.func,
  userdetail: PropTypes.object,
  isResponsive: PropTypes.object
}
const mapStateToProps = ({ Clients, AppoinmentObject, Login }) => (
  {
    clietDetail: Clients.clietDetail,
    deals: Clients.deals,
    loading: Clients.loading,
    listingtypes: AppoinmentObject.listingtypes,
    userdetail: Login.userdetail,

  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  onDeleteDeal: (id) => dispatch(deleteClientDeal(id)),

  onGetClientDeals: (agentId, clientId) => dispatch(getClientDeals(agentId, clientId)),
  onGetListingType: agentId => dispatch(getListingType(agentId)),
  onGetUserDetail: agentId => dispatch(getUserDetail(agentId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientDeals))
